-1 == window.navigator.userAgent.indexOf("Chrome-Lighthouse") && function (e) {
  e = jQuery = e;
  var t, i, s, o, n = {sections: []};
  theme.cartNoteMonitor = {
    load: function (t) {
      t.on("change.themeCartNoteMonitor paste.themeCartNoteMonitor keyup.themeCartNoteMonitor", (function () {
        theme.cartNoteMonitor.postUpdate(e(this).val())
      }))
    }, unload: function (e) {
      e.off(".themeCartNoteMonitor")
    }, updateThrottleTimeoutId: -1, updateThrottleInterval: 500, postUpdate: function (t) {
      clearTimeout(theme.cartNoteMonitor.updateThrottleTimeoutId), theme.cartNoteMonitor.updateThrottleTimeoutId = setTimeout((function () {
        e.post(theme.routes.cart_url + "/update.js", {note: t}, (function (e) {
        }), "json")
      }), theme.cartNoteMonitor.updateThrottleInterval)
    }
  }, theme.scriptsLoaded = {}, theme.loadScriptOnce = function (e, t, i, s) {
    if (void 0 === theme.scriptsLoaded[e]) {
      theme.scriptsLoaded[e] = [];
      var o = document.createElement("script");
      o.src = e, (s || i) && (o.async = !1), i && i(), "function" == typeof t && (theme.scriptsLoaded[e].push(t), o.readyState ? o.onreadystatechange = function () {
        if ("loaded" == o.readyState || "complete" == o.readyState) {
          o.onreadystatechange = null;
          for (var e = 0; e < theme.scriptsLoaded[this].length; e++) theme.scriptsLoaded[this][e]();
          theme.scriptsLoaded[this] = !0
        }
      }.bind(e) : o.onload = function () {
        for (var e = 0; e < theme.scriptsLoaded[this].length; e++) theme.scriptsLoaded[this][e]();
        theme.scriptsLoaded[this] = !0
      }.bind(e));
      var n = document.getElementsByTagName("script")[0];
      return n.parentNode.insertBefore(o, n), !0
    }
    if ("object" != typeof theme.scriptsLoaded[e] || "function" != typeof t) return "function" == typeof t && t(), !1;
    theme.scriptsLoaded[e].push(t)
  }, theme.loadStyleOnce = function (e) {
    var t = e.replace(/^https?:/, "");
    if (!document.querySelector('link[href="' + encodeURI(t) + '"]')) {
      var i = document.createElement("link");
      i.href = t, i.rel = "stylesheet", i.type = "text/css";
      var s = document.getElementsByTagName("link")[0];
      s.parentNode.insertBefore(i, s)
    }
  }, theme.Disclosure = function () {
    var t = "[data-disclosure-list]", i = "[data-disclosure-toggle]", s = "[data-disclosure-input]",
      o = "[data-disclosure-option]", n = "disclosure-list--visible";

    function a(e) {
      this.$container = e, this.cache = {}, this._cacheSelectors(), this._connectOptions(), this._connectToggle(), this._onFocusOut()
    }

    return a.prototype = e.extend({}, a.prototype, {
      _cacheSelectors: function () {
        this.cache = {
          $disclosureList: this.$container.find(t),
          $disclosureToggle: this.$container.find(i),
          $disclosureInput: this.$container.find(s),
          $disclosureOptions: this.$container.find(o)
        }
      }, _connectToggle: function () {
        this.cache.$disclosureToggle.on("click", function (t) {
          var i = "true" === e(t.currentTarget).attr("aria-expanded");
          e(t.currentTarget).attr("aria-expanded", !i), this.cache.$disclosureList.toggleClass(n)
        }.bind(this))
      }, _connectOptions: function () {
        this.cache.$disclosureOptions.on("click", function (t) {
          t.preventDefault(), this._submitForm(e(t.currentTarget).data("value"))
        }.bind(this))
      }, _onFocusOut: function () {
        this.cache.$disclosureToggle.on("focusout", function (e) {
          0 === this.$container.has(e.relatedTarget).length && this._hideList()
        }.bind(this)), this.cache.$disclosureList.on("focusout", function (t) {
          var i = e(t.currentTarget).has(t.relatedTarget).length > 0;
          this.cache.$disclosureList.hasClass(n) && !i && this._hideList()
        }.bind(this)), this.$container.on("keyup", function (e) {
          27 === e.which && (this._hideList(), this.cache.$disclosureToggle.focus())
        }.bind(this)), this.bodyOnClick = function (e) {
          var t = this.$container.has(e.target).length > 0;
          this.cache.$disclosureList.hasClass(n) && !t && this._hideList()
        }.bind(this), e("body").on("click", this.bodyOnClick)
      }, _submitForm: function (e) {
        this.cache.$disclosureInput.val(e), this.$container.parents("form").submit()
      }, _hideList: function () {
        this.cache.$disclosureList.removeClass(n), this.cache.$disclosureToggle.attr("aria-expanded", !1)
      }, unload: function () {
        e("body").off("click", this.bodyOnClick), this.cache.$disclosureOptions.off(), this.cache.$disclosureToggle.off(), this.cache.$disclosureList.off(), this.$container.off()
      }
    }), a
  }(), (t = document.createEvent("Event")).initEvent("throttled-scroll", !0, !0), window.addEventListener("scroll", (i = function () {
    window.dispatchEvent(t)
  }, s = -1, o = !1, function () {
    clearTimeout(s), s = setTimeout(i, 200), o || (i.call(), o = !0, setTimeout((function () {
      o = !1
    }), 200))
  })), theme.Sections = new function () {
    var t = this;
    t._instances = [], t._deferredSectionTargets = [], t._sections = [], t._deferredLoadViewportExcess = 300, t._deferredWatcherRunning = !1, t.init = function () {
      e(document).on("shopify:section:load", (function (e) {
        var i = t._themeSectionTargetFromShopifySectionTarget(e.target);
        i && t.sectionLoad(i)
      })).on("shopify:section:unload", (function (e) {
        var i = t._themeSectionTargetFromShopifySectionTarget(e.target);
        i && t.sectionUnload(i)
      })).on("shopify:section:reorder", (function (e) {
        var i = t._themeSectionTargetFromShopifySectionTarget(e.target);
        i && t.sectionReorder(i)
      })), e(window).on("throttled-scroll.themeSectionDeferredLoader debouncedresize.themeSectionDeferredLoader", t._processDeferredSections), t._deferredWatcherRunning = !0
    }, t.register = function (i, s, o) {
      t._sections.push({
        type: i,
        section: s,
        afterSectionLoadCallback: o ? o.afterLoad : null,
        afterSectionUnloadCallback: o ? o.afterUnload : null
      }), e('[data-section-type="' + i + '"]').each((function () {
        Shopify.designMode || o && !1 === o.deferredLoad || !t._deferredWatcherRunning ? t.sectionLoad(this) : t.sectionDeferredLoad(this, o)
      }))
    }, t.sectionDeferredLoad = function (e, i) {
      t._deferredSectionTargets.push({
        target: e,
        deferredLoadViewportExcess: i && i.deferredLoadViewportExcess ? i.deferredLoadViewportExcess : t._deferredLoadViewportExcess
      }), t._processDeferredSections(!0)
    }, t._processDeferredSections = function (i) {
      if (t._deferredSectionTargets.length) for (var s = e(window).scrollTop(), o = s + e(window).height(), n = !0 === i ? t._deferredSectionTargets.length - 1 : 0; n < t._deferredSectionTargets.length; n++) {
        var a = t._deferredSectionTargets[n].target, r = t._deferredSectionTargets[n].deferredLoadViewportExcess,
          c = e(a).offset().top - r, l = c > s && c < o;
        if (!l) {
          var d = c + e(a).outerHeight() + 2 * r;
          l = d > s && d < o
        }
        (l || c < s && d > o) && (t.sectionLoad(a), t._deferredSectionTargets.splice(n, 1), n--)
      }
      !0 !== i && 0 === t._deferredSectionTargets.length && (t._deferredWatcherRunning = !1, e(window).off(".themeSectionDeferredLoader"))
    }, t.sectionLoad = function (i) {
      var s, o = t._sectionForTarget(i);
      if (!1 !== (s = o.section ? o.section : o)) {
        var n = {
          target: i,
          section: s,
          $shopifySectionContainer: e(i).closest(".shopify-section"),
          thisContext: {functions: s.functions, registeredEventListeners: []}
        };
        n.thisContext.registerEventListener = t._registerEventListener.bind(n.thisContext), t._instances.push(n), e(i).data("components") && e(i).data("components").split(",").forEach((t => {
          e(document).trigger("cc:component:load", [t, i])
        })), t._callSectionWith(s, "onSectionLoad", i, n.thisContext), t._callSectionWith(s, "afterSectionLoadCallback", i, n.thisContext), s.onSectionSelect && n.$shopifySectionContainer.on("shopify:section:select", (function (e) {
          t._callSectionWith(s, "onSectionSelect", e.target, n.thisContext)
        })), s.onSectionDeselect && n.$shopifySectionContainer.on("shopify:section:deselect", (function (e) {
          t._callSectionWith(s, "onSectionDeselect", e.target, n.thisContext)
        })), s.onBlockSelect && e(i).on("shopify:block:select", (function (e) {
          t._callSectionWith(s, "onBlockSelect", e.target, n.thisContext)
        })), s.onBlockDeselect && e(i).on("shopify:block:deselect", (function (e) {
          t._callSectionWith(s, "onBlockDeselect", e.target, n.thisContext)
        }))
      }
    }, t.sectionUnload = function (i) {
      for (var s = t._sectionForTarget(i), o = -1, n = 0; n < t._instances.length; n++) t._instances[n].target == i && (o = n);
      if (o > -1) {
        var a = t._instances[o];
        e(i).off("shopify:block:select shopify:block:deselect"), a.$shopifySectionContainer.off("shopify:section:select shopify:section:deselect"), t._callSectionWith(a.section, "onSectionUnload", i, a.thisContext), t._unloadRegisteredEventListeners(a.thisContext.registeredEventListeners), t._callSectionWith(s, "afterSectionUnloadCallback", i, a.thisContext), t._instances.splice(o), e(i).data("components") && e(i).data("components").split(",").forEach((t => {
          e(document).trigger("cc:component:unload", [t, i])
        }))
      } else for (n = 0; n < t._deferredSectionTargets.length; n++) if (t._deferredSectionTargets[n].target == i) {
        t._deferredSectionTargets[n].splice(n, 1);
        break
      }
    }, t.sectionReorder = function (e) {
      for (var i = -1, s = 0; s < t._instances.length; s++) t._instances[s].target == e && (i = s);
      if (i > -1) {
        var o = t._instances[i];
        t._callSectionWith(o.section, "onSectionReorder", e, o.thisContext)
      }
    }, t._registerEventListener = function (e, t, i) {
      e.addEventListener(t, i), this.registeredEventListeners.push({element: e, eventType: t, callback: i})
    }, t._unloadRegisteredEventListeners = function (e) {
      e.forEach((e => {
        e.element.removeEventListener(e.eventType, e.callback)
      }))
    }, t._callSectionWith = function (e, t, i, s) {
      if ("function" == typeof e[t]) try {
        s ? e[t].bind(s)(i) : e[t](i)
      } catch (e) {
        var o = i.dataset.sectionType;
        console.warn("Theme warning: '".concat(t, "' failed for section '").concat(o, "'")), console.debug(i, e)
      }
    }, t._themeSectionTargetFromShopifySectionTarget = function (t) {
      var i = e("[data-section-type]:first", t);
      return i.length > 0 && i[0]
    }, t._sectionForTarget = function (i) {
      for (var s = e(i).attr("data-section-type"), o = 0; o < t._sections.length; o++) if (t._sections[o].type == s) return t._sections[o];
      return !1
    }, t._sectionAlreadyRegistered = function (e) {
      for (var i = 0; i < t._sections.length; i++) if (t._sections[i].type == e) return !0;
      return !1
    }
  };

  class a {
    constructor(t) {
      var i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ".cc-".concat(t), s = this;
      this.instances = [], e(document).on("cc:component:load", (function (o, n, a) {
        n === t && e(a).find("".concat(i, ":not(.cc-initialized)")).each((function () {
          s.init(this)
        }))
      })), e(document).on("cc:component:unload", (function (o, n, a) {
        n === t && e(a).find(i).each((function () {
          s.destroy(this)
        }))
      })), e(i).each((function () {
        s.init(this)
      }))
    }

    init(t) {
      e(t).addClass("cc-initialized")
    }

    destroy(t) {
      e(t).removeClass("cc-initialized")
    }

    registerInstance(e, t) {
      this.instances.push({container: e, instance: t})
    }

    destroyInstance(e) {
      this.instances = this.instances.filter((t => {
        if (t.container === e) return "function" == typeof t.instance.destroy && t.instance.destroy(), t.container !== e
      }))
    }
  }

  theme.showQuickPopup = function (t, i) {
    var s = e('<div class="simple-popup"/>'), o = i.offset();
    s.html(t).css({left: o.left, top: o.top}).hide(), e("body").append(s), s.css({
      marginTop: -s.outerHeight() - 10,
      marginLeft: -(s.outerWidth() - i.outerWidth()) / 2
    }), s.fadeIn(200).delay(3500).fadeOut(400, (function () {
      e(this).remove()
    }))
  }, theme.Shopify = {
    formatMoney: function (e, t) {
      function i(e, t) {
        return void 0 === e ? t : e
      }

      function s(e, t, s, o) {
        if (t = i(t, 2), s = i(s, ","), o = i(o, "."), isNaN(e) || null == e) return 0;
        var n = (e = (e / 100).toFixed(t)).split(".");
        return n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + s) + (n[1] ? o + n[1] : "")
      }

      "string" == typeof e && (e = e.replace(".", ""));
      var o = "", n = /\{\{\s*(\w+)\s*\}\}/, a = t || this.money_format;
      switch (a.match(n)[1]) {
        case"amount":
          o = s(e, 2);
          break;
        case"amount_no_decimals":
          o = s(e, 0);
          break;
        case"amount_with_comma_separator":
          o = s(e, 2, ".", ",");
          break;
        case"amount_with_space_separator":
          o = s(e, 2, " ", ",");
          break;
        case"amount_with_period_and_space_separator":
          o = s(e, 2, " ", ".");
          break;
        case"amount_no_decimals_with_comma_separator":
          o = s(e, 0, ".", ",");
          break;
        case"amount_no_decimals_with_space_separator":
          o = s(e, 0, " ", "");
          break;
        case"amount_with_apostrophe_separator":
          o = s(e, 2, "'", ".");
          break;
        case"amount_with_decimal_separator":
          o = s(e, 2, ".", ".")
      }
      return a.replace(n, o)
    }, formatImage: function (e, t) {
      return e ? e.replace(/^(.*)\.([^\.]*)$/g, "$1_" + t + ".$2") : ""
    }, Image: {
      imageSize: function (e) {
        var t = e.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);
        return null !== t ? t[1] : null
      }, getSizedImageUrl: function (e, t) {
        if (null == t) return e;
        if ("master" == t) return this.removeProtocol(e);
        var i = e.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
        if (null != i) {
          var s = e.split(i[0]), o = i[0];
          return this.removeProtocol(s[0] + "_" + t + o)
        }
        return null
      }, removeProtocol: function (e) {
        return e.replace(/http(s)?:/, "")
      }
    }
  };

  class r {
    constructor(e) {
      this.el = e, this.button = e.querySelector(".cc-select__btn"), this.listbox = e.querySelector(".cc-select__listbox"), this.options = e.querySelectorAll(".cc-select__option"), this.selectedOption = e.querySelector('[aria-selected="true"]'), this.nativeSelect = document.getElementById("".concat(e.id, "-native")), this.swatches = "swatch" in this.options[this.options.length - 1].dataset, this.focusedClass = "is-focused", this.searchString = "", this.listboxOpen = !1, this.selectedOption || (this.selectedOption = this.listbox.firstElementChild), this.bindEvents(), this.setButtonWidth()
    }

    bindEvents() {
      this.el.addEventListener("keydown", this.handleKeydown.bind(this)), this.el.addEventListener("selectOption", this.handleSelectOption.bind(this)), this.button.addEventListener("mousedown", this.handleMousedown.bind(this))
    }

    addListboxOpenEvents() {
      this.mouseoverHandler = this.handleMouseover.bind(this), this.mouseleaveHandler = this.handleMouseleave.bind(this), this.clickHandler = this.handleClick.bind(this), this.blurHandler = this.handleBlur.bind(this), this.listbox.addEventListener("mouseover", this.mouseoverHandler), this.listbox.addEventListener("mouseleave", this.mouseleaveHandler), this.listbox.addEventListener("click", this.clickHandler), this.listbox.addEventListener("blur", this.blurHandler)
    }

    removeListboxOpenEvents() {
      this.listbox.removeEventListener("mouseover", this.mouseoverHandler), this.listbox.removeEventListener("mouseleave", this.mouseleaveHandler), this.listbox.removeEventListener("click", this.clickHandler), this.listbox.removeEventListener("blur", this.blurHandler)
    }

    handleKeydown(e) {
      this.listboxOpen ? this.handleKeyboardNav(e) : ("ArrowUp" === e.key || "ArrowDown" === e.key || " " === e.key) && (e.preventDefault(), this.showListbox())
    }

    handleMousedown(e) {
      this.listboxOpen || 0 !== e.button || this.showListbox()
    }

    handleMouseover(e) {
      e.target.matches("li") && this.focusOption(e.target)
    }

    handleMouseleave() {
      this.focusOption(this.selectedOption)
    }

    handleClick(e) {
      e.target.matches(".js-option") && this.selectOption(e.target)
    }

    handleBlur() {
      this.listboxOpen && this.hideListbox()
    }

    handleKeyboardNav(e) {
      var t;
      switch ("Tab" === e.key && e.preventDefault(), e.key) {
        case"ArrowUp":
        case"ArrowDown":
          e.preventDefault(), (t = "ArrowUp" === e.key ? this.focusedOption.previousElementSibling : this.focusedOption.nextElementSibling) && !t.classList.contains("is-disabled") && this.focusOption(t);
          break;
        case"Enter":
        case" ":
          e.preventDefault(), this.selectOption(this.focusedOption);
          break;
        case"Escape":
          e.preventDefault(), this.hideListbox();
          break;
        default:
          (t = this.findOption(e.key)) && this.focusOption(t)
      }
    }

    setButtonWidth() {
      var e = e => {
          var t = getComputedStyle(e);
          return parseFloat(t.paddingLeft) + parseFloat(t.paddingRight)
        }, t = e(this.button), i = e(this.selectedOption), s = this.button.offsetWidth - this.button.clientWidth,
        o = Math.ceil(this.selectedOption.getBoundingClientRect().width);
      this.button.style.width = "".concat(o - i + t + s, "px")
    }

    showListbox() {
      this.listbox.hidden = !1, this.listboxOpen = !0, this.el.classList.add("is-open"), this.button.setAttribute("aria-expanded", "true"), this.listbox.setAttribute("aria-hidden", "false"), setTimeout((() => {
        this.focusOption(this.selectedOption), this.listbox.focus(), this.addListboxOpenEvents()
      }), 10)
    }

    hideListbox() {
      this.listboxOpen && (this.listbox.hidden = !0, this.listboxOpen = !1, this.el.classList.remove("is-open"), this.button.setAttribute("aria-expanded", "false"), this.listbox.setAttribute("aria-hidden", "true"), this.focusedOption && (this.focusedOption.classList.remove(this.focusedClass), this.focusedOption = null), this.button.focus(), this.removeListboxOpenEvents())
    }

    findOption(e) {
      return this.searchString += e, this.searchTimer && clearTimeout(this.searchTimer), this.searchTimer = setTimeout((() => {
        this.searchString = ""
      }), 500), [...this.options].find((e => e.innerText.toLowerCase().includes(this.searchString) && !e.classList.contains("is-disabled")))
    }

    focusOption(e) {
      if (this.focusedOption && this.focusedOption.classList.remove(this.focusedClass), this.focusedOption = e, this.focusedOption.classList.add(this.focusedClass), this.listbox.scrollHeight > this.listbox.clientHeight) {
        var t = this.listbox.clientHeight + this.listbox.scrollTop, i = e.offsetTop + e.offsetHeight;
        i > t ? this.listbox.scrollTop = i - this.listbox.clientHeight : e.offsetTop < this.listbox.scrollTop && (this.listbox.scrollTop = e.offsetTop)
      }
    }

    handleSelectOption(e) {
      var t = [...this.options].find((t => t.dataset.value === e.detail.value));
      t && this.selectOption(t)
    }

    selectOption(e) {
      if (e !== this.selectedOption) if (e.setAttribute("aria-selected", "true"), this.selectedOption.setAttribute("aria-selected", "false"), this.swatches && (e.dataset.swatch ? this.button.dataset.swatch = e.dataset.swatch : this.button.removeAttribute("data-swatch")), this.button.firstChild.textContent = e.firstElementChild.textContent, this.listbox.setAttribute("aria-activedescendant", e.id), this.selectedOption = document.getElementById(e.id), this.nativeSelect) this.nativeSelect.value = e.dataset.value, this.nativeSelect.dispatchEvent(new Event("change", {bubbles: !0})); else {
        var t = {selectedValue: e.dataset.value};
        this.el.dispatchEvent(new CustomEvent("change", {bubbles: !0, detail: t}))
      }
      this.hideListbox()
    }
  }

  new class extends a {
    constructor() {
      super(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "custom-select", arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ".cc-select")
    }

    init(e) {
      super.init(e), this.registerInstance(e, new r(e))
    }

    destroy(e) {
      this.destroyInstance(e), super.destroy(e)
    }
  };

  class c {
    constructor(e) {
      this.filteringEnabled = "true" === e.dataset.filtering, this.sortingEnabled = "true" === e.dataset.sorting, this.filtersControl = document.querySelector(".cc-filters-control"), this.filtersContainer = document.querySelector(".cc-filters-container"), this.results = document.querySelector(".cc-filters-results"), this.filteringEnabled && (this.filters = document.querySelector(".cc-filters"), this.filtersFooter = document.querySelector(".cc-filters__footer"), this.activeFilters = document.querySelector(".cc-active-filters"), this.clearFiltersBtn = document.querySelector(".js-clear-filters")), this.sortingEnabled && (this.sortBy = document.querySelector(".cc-filter--sort"), this.activeSortText = document.querySelector(".cc-sort-selected")), this.utils = {
        hidden: "is-hidden",
        loading: "is-loading",
        open: "is-open",
        filtersOpen: "filters-open"
      }, this.filteringEnabled && !this.filtersFooter.classList.contains(this.utils.hidden) && (this.filters.style.height = "calc(100% - ".concat(this.filtersFooter.offsetHeight, "px)")), this.bindEvents()
    }

    bindEvents() {
      this.filtersControl.addEventListener("click", this.handleControlClick.bind(this)), this.filtersContainer.addEventListener("click", this.handleFiltersClick.bind(this)), this.filtersContainer.addEventListener("input", this.debounce(this.handleFilterChange.bind(this), 500)), this.filteringEnabled && (document.querySelector(".cc-price-range") && this.filtersContainer.addEventListener("change", this.debounce(this.handleFilterChange.bind(this), 500)), this.activeFilters.addEventListener("click", this.handleActiveFiltersClick.bind(this))), document.addEventListener("click", this.handleClickOutside.bind(this)), window.addEventListener("popstate", this.handleHistoryChange.bind(this))
    }

    debounce(e, t) {
      var i, s = this;
      return function () {
        for (var o = arguments.length, n = Array(o), a = 0; a < o; a++) n[a] = arguments[a];
        clearTimeout(i), i = setTimeout((() => e.apply(s, n)), t)
      }
    }

    handleControlClick(e) {
      e.target.matches(".cc-filters-control__btn") && (document.body.classList.add(this.utils.filtersOpen), e.target.matches(".js-show-filters") ? this.filters.classList.add(this.utils.open) : (this.sortBy.open = !0, setTimeout((() => {
        this.sortBy.classList.add(this.utils.open)
      }), 10)))
    }

    handleFiltersClick(e) {
      var {target: t} = e, i = t.closest(".cc-filter");
      if (t.matches(".cc-filter-clear-btn")) return e.preventDefault(), void this.applyFilters(new URL(e.target.href).searchParams.toString(), e);
      if (t.matches(".js-close-filters")) return i && setTimeout((() => {
        i.classList.remove(this.utils.open), i.open = !1
      }), 300), this.filteringEnabled && this.filters.classList.remove(this.utils.open), void document.body.classList.remove(this.utils.filtersOpen);
      if (t.matches(".cc-filter__toggle") || t.matches(".cc-filter-back-btn")) {
        var s = document.querySelector('.cc-filter[open]:not([data-index="'.concat(i.dataset.index, '"])'));
        s && this.closeFilter(s, !1), i.classList.contains(this.utils.open) ? (e.preventDefault(), this.closeFilter(i)) : setTimeout((() => {
          i.classList.add(this.utils.open)
        }), 10)
      }
    }

    handleClickOutside(e) {
      var t = document.querySelector(".cc-filter.".concat(this.utils.open));
      if (t) {
        var i = e.target.closest(".cc-filter");
        i && i === t || this.closeFilter(t)
      }
    }

    handleFilterChange(e) {
      if ("change" !== e.type || e.detail && "theme:component:price_range" === e.detail.sender) {
        "input" === e.type && e.target.classList.contains("cc-price-range__input") && e.target.dispatchEvent(new Event("change", {bubbles: !0}));
        var t = new FormData(document.getElementById("filters")), i = new URLSearchParams(t);
        this.applyFilters(i.toString(), e)
      }
    }

    handleActiveFiltersClick(e) {
      e.preventDefault(), "A" === e.target.tagName && this.applyFilters(new URL(e.target.href).searchParams.toString(), e)
    }

    handleHistoryChange(e) {
      var t = "";
      e.state && e.state.searchParams && (t = e.state.searchParams), this.applyFilters(t, null, !1)
    }

    applyFilters(e, t) {
      var i = !(arguments.length > 2) || void 0 === arguments[2] || arguments[2];
      this.results.classList.add(this.utils.loading), fetch("".concat(window.location.pathname, "?").concat(e)).then((e => e.text())).then((e => {
        var i = document.implementation.createHTMLDocument();
        i.documentElement.innerHTML = e, i.querySelector(".cc-facet-filters") && this.updateFilters(i, t), this.results.innerHTML = i.querySelector(".cc-filters-results").innerHTML, document.dispatchEvent(new CustomEvent("filters-applied", {bubbles: !0})), this.results.classList.remove(this.utils.loading)
      })), i && this.updateURL(e)
    }

    updateFilters(e, t) {
      if (this.filtersControl.innerHTML = e.querySelector(".cc-filters-control").innerHTML, t && "sort_by" === t.target.name && (this.activeSortText.textContent = t.target.nextElementSibling.textContent), this.filteringEnabled) {
        document.querySelectorAll(".cc-filter").forEach((i => {
          var {index: s} = i.dataset;
          if ("0" !== s) {
            var o = e.querySelector('.cc-filter[data-index="'.concat(s, '"]'));
            if ("price_range" === i.dataset.type) this.updateFilter(i, o, !1), t && "INPUT" === t.target.tagName || i.querySelectorAll("input").forEach((t => {
              t.value = e.getElementById(t.id).value, t.dispatchEvent(new CustomEvent("change", {
                bubbles: !0,
                detail: {sender: "reset"}
              }))
            })); else if (t && "INPUT" === t.target.tagName) {
              var n = t.target.closest(".cc-filter");
              this.updateFilter(i, o, i.dataset.index !== n.dataset.index)
            } else this.updateFilter(i, o, !0)
          }
        })), this.updateActiveFilters(e), this.clearFiltersBtn.hidden = e.querySelector(".js-clear-filters").hidden;
        var i = e.querySelector(".cc-filters__footer"), s = i.classList.contains(this.utils.hidden);
        this.filtersFooter.innerHTML = i.innerHTML, this.filtersFooter.classList.toggle(this.utils.hidden, s), this.filters.style.height = s ? null : "calc(100% - ".concat(this.filtersFooter.offsetHeight, "px)")
      }
    }

    updateFilter(e, t, i) {
      i ? e.innerHTML = t.innerHTML : (e.replaceChild(t.querySelector(".cc-filter__toggle"), e.querySelector(".cc-filter__toggle")), e.querySelector(".cc-filter__header").innerHTML = t.querySelector(".cc-filter__header").innerHTML)
    }

    updateActiveFilters(e) {
      var t = e.querySelector(".cc-active-filters");
      this.activeFilters.innerHTML = t.innerHTML, this.activeFilters.hidden = !this.activeFilters.querySelector(".cc-active-filter")
    }

    updateURL(e) {
      history.pushState({searchParams: e}, "", "".concat(window.location.pathname).concat(e && "?".concat(e)))
    }

    closeFilter(e) {
      var t = !(arguments.length > 1) || void 0 === arguments[1] || arguments[1];
      clearTimeout(this.closeTimer), e.classList.remove(this.utils.open), this.closeTimer = setTimeout((() => {
        e.open = !1
      }), t ? 300 : null)
    }
  }

  new class extends a {
    constructor() {
      super(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "facet-filters", arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ".cc-facet-filters")
    }

    init(e) {
      super.init(e), this.registerInstance(e, new c(e))
    }

    destroy(e) {
      this.destroyInstance(e), super.destroy(e)
    }
  };

  class l {
    constructor(e) {
      this.container = e, this.selectors = {
        inputMin: ".cc-price-range__input--min",
        inputMax: ".cc-price-range__input--max",
        control: ".cc-price-range__control",
        controlMin: ".cc-price-range__control--min",
        controlMax: ".cc-price-range__control--max",
        bar: ".cc-price-range__bar",
        activeBar: ".cc-price-range__bar-active"
      }, this.controls = {
        min: {
          barControl: e.querySelector(this.selectors.controlMin),
          input: e.querySelector(this.selectors.inputMin)
        },
        max: {barControl: e.querySelector(this.selectors.controlMax), input: e.querySelector(this.selectors.inputMax)}
      }, this.controls.min.value = parseInt("" === this.controls.min.input.value ? this.controls.min.input.placeholder : this.controls.min.input.value), this.controls.max.value = parseInt("" === this.controls.max.input.value ? this.controls.max.input.placeholder : this.controls.max.input.value), this.valueMin = this.controls.min.input.min, this.valueMax = this.controls.min.input.max, this.valueRange = this.valueMax - this.valueMin, [this.controls.min, this.controls.max].forEach((e => {
        e.barControl.setAttribute("aria-valuemin", this.valueMin), e.barControl.setAttribute("aria-valuemax", this.valueMax)
      })), this.controls.min.barControl.setAttribute("aria-valuenow", this.controls.min.value), this.controls.max.barControl.setAttribute("aria-valuenow", this.controls.max.value), this.bar = e.querySelector(this.selectors.bar), this.activeBar = e.querySelector(this.selectors.activeBar), this.inDrag = !1, this.bindEvents(), this.render()
    }

    getPxToValueRatio() {
      return this.bar.clientWidth / (this.valueMax - this.valueMin)
    }

    getPcToValueRatio() {
      return 100 / (this.valueMax - this.valueMin)
    }

    setActiveControlValue(e, t) {
      this.activeControl === this.controls.min ? ("" === e && (e = this.valueMin), e = Math.min(e = Math.max(this.valueMin, e), this.controls.max.value)) : ("" === e && (e = this.valueMax), e = Math.max(e = Math.min(this.valueMax, e), this.controls.min.value)), this.activeControl.value = Math.round(e), this.activeControl.input.value == this.activeControl.value || (this.activeControl.value == this.activeControl.input.placeholder ? this.activeControl.input.value = "" : this.activeControl.input.value = this.activeControl.value, t || this.activeControl.input.dispatchEvent(new CustomEvent("change", {
        bubbles: !0,
        detail: {sender: "theme:component:price_range"}
      }))), this.activeControl.barControl.setAttribute("aria-valuenow", this.activeControl.value)
    }

    render() {
      this.drawControl(this.controls.min), this.drawControl(this.controls.max), this.drawActiveBar()
    }

    drawControl(e) {
      e.barControl.style.left = "".concat((e.value - this.valueMin) * this.getPcToValueRatio(), "%")
    }

    drawActiveBar() {
      this.activeBar.style.left = "".concat((this.controls.min.value - this.valueMin) * this.getPcToValueRatio(), "%"), this.activeBar.style.right = "".concat((this.valueMax - this.controls.max.value) * this.getPcToValueRatio(), "%")
    }

    handleControlTouchStart(e) {
      e.preventDefault(), this.startDrag(e.target, e.touches[0].clientX), this.boundControlTouchMoveEvent = this.handleControlTouchMove.bind(this), this.boundControlTouchEndEvent = this.handleControlTouchEnd.bind(this), window.addEventListener("touchmove", this.boundControlTouchMoveEvent), window.addEventListener("touchend", this.boundControlTouchEndEvent)
    }

    handleControlTouchMove(e) {
      this.moveDrag(e.touches[0].clientX)
    }

    handleControlTouchEnd(e) {
      e.preventDefault(), window.removeEventListener("touchmove", this.boundControlTouchMoveEvent), window.removeEventListener("touchend", this.boundControlTouchEndEvent), this.stopDrag()
    }

    handleControlMouseDown(e) {
      e.preventDefault(), this.startDrag(e.target, e.clientX), this.boundControlMouseMoveEvent = this.handleControlMouseMove.bind(this), this.boundControlMouseUpEvent = this.handleControlMouseUp.bind(this), window.addEventListener("mousemove", this.boundControlMouseMoveEvent), window.addEventListener("mouseup", this.boundControlMouseUpEvent)
    }

    handleControlMouseMove(e) {
      this.moveDrag(e.clientX)
    }

    handleControlMouseUp(e) {
      e.preventDefault(), window.removeEventListener("mousemove", this.boundControlMouseMoveEvent), window.removeEventListener("mouseup", this.boundControlMouseUpEvent), this.stopDrag()
    }

    startDrag(e, t) {
      this.activeControl = this.controls.min.barControl === e ? this.controls.min : this.controls.max, this.dragStartX = t, this.dragStartValue = this.activeControl.value, this.inDrag = !0
    }

    moveDrag(e) {
      if (this.inDrag) {
        var t = this.dragStartValue + (e - this.dragStartX) / this.getPxToValueRatio();
        this.setActiveControlValue(t), this.render()
      }
    }

    stopDrag() {
      this.inDrag = !1
    }

    handleInputChange(e) {
      if ("INPUT" === e.target.tagName && (!e.detail || "theme:component:price_range" !== e.detail.sender)) {
        var t = e.detail && "reset" === e.detail.sender;
        this.activeControl = this.controls.min.input === e.target ? this.controls.min : this.controls.max, this.setActiveControlValue(e.target.value, t), this.render()
      }
    }

    bindEvents() {
      [this.controls.min, this.controls.max].forEach((e => {
        e.barControl.addEventListener("touchstart", this.handleControlTouchStart.bind(this)), e.barControl.addEventListener("mousedown", this.handleControlMouseDown.bind(this))
      })), this.container.addEventListener("change", this.handleInputChange.bind(this))
    }

    destroy() {
    }
  }

  new class extends a {
    constructor() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "price-range";
      super(e, arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ".cc-".concat(e))
    }

    init(e) {
      super.init(e), this.registerInstance(e, new l(e))
    }

    destroy(e) {
      this.destroyInstance(e), super.destroy(e)
    }
  };

  class d {
    constructor(e, t) {
      this.$container = e, this.namespace = t, this.cssClasses = {
        visible: "cc-popup--visible",
        bodyNoScroll: "cc-popup-no-scroll",
        bodyNoScrollPadRight: "cc-popup-no-scroll-pad-right"
      }
    }

    open(t) {
      if (this.$container.data("freeze-scroll")) {
        clearTimeout(theme.ccPopupRemoveScrollFreezeTimeoutId), e("body").addClass(this.cssClasses.bodyNoScroll);
        var i = document.createElement("div");
        i.className = "popup-scrollbar-measure", document.body.appendChild(i);
        var s = i.getBoundingClientRect().width - i.clientWidth;
        document.body.removeChild(i), s > 0 && e("body").css("padding-right", s + "px").addClass(this.cssClasses.bodyNoScrollPadRight)
      }
      this.$container.addClass(this.cssClasses.visible), this.previouslyActiveElement = document.activeElement, setTimeout((() => {
        this.$container.find(".cc-popup-close")[0].focus()
      }), 500), e(window).on("keydown" + this.namespace, (e => {
        27 === e.keyCode && this.close()
      })), t && t()
    }

    close(t) {
      if (this.$container.removeClass(this.cssClasses.visible), this.previouslyActiveElement && e(this.previouslyActiveElement).focus(), e(window).off("keydown" + this.namespace), 0 === e("." + this.cssClasses.visible).filter((() => this.$container.data("freeze-scroll"))).length) {
        var i = 500, s = this.$container.find(".cc-popup-modal");
        s.length && (i = parseFloat(getComputedStyle(s[0]).transitionDuration)) && i > 0 && (i *= 1e3), theme.ccPopupRemoveScrollFreezeTimeoutId = setTimeout((() => {
          e("body").removeClass(this.cssClasses.bodyNoScroll).removeClass(this.cssClasses.bodyNoScrollPadRight).css("padding-right", "0")
        }), i)
      }
      t && t()
    }
  }

  theme.MapSection = new function () {
    var t = this;
    t.config = {
      zoom: 14, styles: {
        default: [],
        silver: [{elementType: "geometry", stylers: [{color: "#f5f5f5"}]}, {
          elementType: "labels.icon",
          stylers: [{visibility: "off"}]
        }, {elementType: "labels.text.fill", stylers: [{color: "#616161"}]}, {
          elementType: "labels.text.stroke",
          stylers: [{color: "#f5f5f5"}]
        }, {
          featureType: "administrative.land_parcel",
          elementType: "labels.text.fill",
          stylers: [{color: "#bdbdbd"}]
        }, {featureType: "poi", elementType: "geometry", stylers: [{color: "#eeeeee"}]}, {
          featureType: "poi",
          elementType: "labels.text.fill",
          stylers: [{color: "#757575"}]
        }, {featureType: "poi.park", elementType: "geometry", stylers: [{color: "#e5e5e5"}]}, {
          featureType: "poi.park",
          elementType: "labels.text.fill",
          stylers: [{color: "#9e9e9e"}]
        }, {featureType: "road", elementType: "geometry", stylers: [{color: "#ffffff"}]}, {
          featureType: "road.arterial",
          elementType: "labels.text.fill",
          stylers: [{color: "#757575"}]
        }, {
          featureType: "road.highway",
          elementType: "geometry",
          stylers: [{color: "#dadada"}]
        }, {
          featureType: "road.highway",
          elementType: "labels.text.fill",
          stylers: [{color: "#616161"}]
        }, {
          featureType: "road.local",
          elementType: "labels.text.fill",
          stylers: [{color: "#9e9e9e"}]
        }, {
          featureType: "transit.line",
          elementType: "geometry",
          stylers: [{color: "#e5e5e5"}]
        }, {
          featureType: "transit.station",
          elementType: "geometry",
          stylers: [{color: "#eeeeee"}]
        }, {featureType: "water", elementType: "geometry", stylers: [{color: "#c9c9c9"}]}, {
          featureType: "water",
          elementType: "labels.text.fill",
          stylers: [{color: "#9e9e9e"}]
        }],
        retro: [{elementType: "geometry", stylers: [{color: "#ebe3cd"}]}, {
          elementType: "labels.text.fill",
          stylers: [{color: "#523735"}]
        }, {elementType: "labels.text.stroke", stylers: [{color: "#f5f1e6"}]}, {
          featureType: "administrative",
          elementType: "geometry.stroke",
          stylers: [{color: "#c9b2a6"}]
        }, {
          featureType: "administrative.land_parcel",
          elementType: "geometry.stroke",
          stylers: [{color: "#dcd2be"}]
        }, {
          featureType: "administrative.land_parcel",
          elementType: "labels.text.fill",
          stylers: [{color: "#ae9e90"}]
        }, {
          featureType: "landscape.natural",
          elementType: "geometry",
          stylers: [{color: "#dfd2ae"}]
        }, {featureType: "poi", elementType: "geometry", stylers: [{color: "#dfd2ae"}]}, {
          featureType: "poi",
          elementType: "labels.text.fill",
          stylers: [{color: "#93817c"}]
        }, {
          featureType: "poi.park",
          elementType: "geometry.fill",
          stylers: [{color: "#a5b076"}]
        }, {
          featureType: "poi.park",
          elementType: "labels.text.fill",
          stylers: [{color: "#447530"}]
        }, {featureType: "road", elementType: "geometry", stylers: [{color: "#f5f1e6"}]}, {
          featureType: "road.arterial",
          elementType: "geometry",
          stylers: [{color: "#fdfcf8"}]
        }, {
          featureType: "road.highway",
          elementType: "geometry",
          stylers: [{color: "#f8c967"}]
        }, {
          featureType: "road.highway",
          elementType: "geometry.stroke",
          stylers: [{color: "#e9bc62"}]
        }, {
          featureType: "road.highway.controlled_access",
          elementType: "geometry",
          stylers: [{color: "#e98d58"}]
        }, {
          featureType: "road.highway.controlled_access",
          elementType: "geometry.stroke",
          stylers: [{color: "#db8555"}]
        }, {
          featureType: "road.local",
          elementType: "labels.text.fill",
          stylers: [{color: "#806b63"}]
        }, {
          featureType: "transit.line",
          elementType: "geometry",
          stylers: [{color: "#dfd2ae"}]
        }, {
          featureType: "transit.line",
          elementType: "labels.text.fill",
          stylers: [{color: "#8f7d77"}]
        }, {
          featureType: "transit.line",
          elementType: "labels.text.stroke",
          stylers: [{color: "#ebe3cd"}]
        }, {
          featureType: "transit.station",
          elementType: "geometry",
          stylers: [{color: "#dfd2ae"}]
        }, {featureType: "water", elementType: "geometry.fill", stylers: [{color: "#b9d3c2"}]}, {
          featureType: "water",
          elementType: "labels.text.fill",
          stylers: [{color: "#92998d"}]
        }],
        dark: [{elementType: "geometry", stylers: [{color: "#212121"}]}, {
          elementType: "labels.icon",
          stylers: [{visibility: "off"}]
        }, {elementType: "labels.text.fill", stylers: [{color: "#757575"}]}, {
          elementType: "labels.text.stroke",
          stylers: [{color: "#212121"}]
        }, {
          featureType: "administrative",
          elementType: "geometry",
          stylers: [{color: "#757575"}]
        }, {
          featureType: "administrative.country",
          elementType: "labels.text.fill",
          stylers: [{color: "#9e9e9e"}]
        }, {
          featureType: "administrative.land_parcel",
          stylers: [{visibility: "off"}]
        }, {
          featureType: "administrative.locality",
          elementType: "labels.text.fill",
          stylers: [{color: "#bdbdbd"}]
        }, {
          featureType: "poi",
          elementType: "labels.text.fill",
          stylers: [{color: "#757575"}]
        }, {featureType: "poi.park", elementType: "geometry", stylers: [{color: "#181818"}]}, {
          featureType: "poi.park",
          elementType: "labels.text.fill",
          stylers: [{color: "#616161"}]
        }, {
          featureType: "poi.park",
          elementType: "labels.text.stroke",
          stylers: [{color: "#1b1b1b"}]
        }, {featureType: "road", elementType: "geometry.fill", stylers: [{color: "#2c2c2c"}]}, {
          featureType: "road",
          elementType: "labels.text.fill",
          stylers: [{color: "#8a8a8a"}]
        }, {
          featureType: "road.arterial",
          elementType: "geometry",
          stylers: [{color: "#373737"}]
        }, {
          featureType: "road.highway",
          elementType: "geometry",
          stylers: [{color: "#3c3c3c"}]
        }, {
          featureType: "road.highway.controlled_access",
          elementType: "geometry",
          stylers: [{color: "#4e4e4e"}]
        }, {
          featureType: "road.local",
          elementType: "labels.text.fill",
          stylers: [{color: "#616161"}]
        }, {
          featureType: "transit",
          elementType: "labels.text.fill",
          stylers: [{color: "#757575"}]
        }, {featureType: "water", elementType: "geometry", stylers: [{color: "#000000"}]}, {
          featureType: "water",
          elementType: "labels.text.fill",
          stylers: [{color: "#3d3d3d"}]
        }],
        night: [{elementType: "geometry", stylers: [{color: "#242f3e"}]}, {
          elementType: "labels.text.fill",
          stylers: [{color: "#746855"}]
        }, {elementType: "labels.text.stroke", stylers: [{color: "#242f3e"}]}, {
          featureType: "administrative.locality",
          elementType: "labels.text.fill",
          stylers: [{color: "#d59563"}]
        }, {
          featureType: "poi",
          elementType: "labels.text.fill",
          stylers: [{color: "#d59563"}]
        }, {featureType: "poi.park", elementType: "geometry", stylers: [{color: "#263c3f"}]}, {
          featureType: "poi.park",
          elementType: "labels.text.fill",
          stylers: [{color: "#6b9a76"}]
        }, {featureType: "road", elementType: "geometry", stylers: [{color: "#38414e"}]}, {
          featureType: "road",
          elementType: "geometry.stroke",
          stylers: [{color: "#212a37"}]
        }, {
          featureType: "road",
          elementType: "labels.text.fill",
          stylers: [{color: "#9ca5b3"}]
        }, {
          featureType: "road.highway",
          elementType: "geometry",
          stylers: [{color: "#746855"}]
        }, {
          featureType: "road.highway",
          elementType: "geometry.stroke",
          stylers: [{color: "#1f2835"}]
        }, {
          featureType: "road.highway",
          elementType: "labels.text.fill",
          stylers: [{color: "#f3d19c"}]
        }, {
          featureType: "transit",
          elementType: "geometry",
          stylers: [{color: "#2f3948"}]
        }, {
          featureType: "transit.station",
          elementType: "labels.text.fill",
          stylers: [{color: "#d59563"}]
        }, {featureType: "water", elementType: "geometry", stylers: [{color: "#17263c"}]}, {
          featureType: "water",
          elementType: "labels.text.fill",
          stylers: [{color: "#515c6d"}]
        }, {featureType: "water", elementType: "labels.text.stroke", stylers: [{color: "#17263c"}]}],
        aubergine: [{elementType: "geometry", stylers: [{color: "#1d2c4d"}]}, {
          elementType: "labels.text.fill",
          stylers: [{color: "#8ec3b9"}]
        }, {elementType: "labels.text.stroke", stylers: [{color: "#1a3646"}]}, {
          featureType: "administrative.country",
          elementType: "geometry.stroke",
          stylers: [{color: "#4b6878"}]
        }, {
          featureType: "administrative.land_parcel",
          elementType: "labels.text.fill",
          stylers: [{color: "#64779e"}]
        }, {
          featureType: "administrative.province",
          elementType: "geometry.stroke",
          stylers: [{color: "#4b6878"}]
        }, {
          featureType: "landscape.man_made",
          elementType: "geometry.stroke",
          stylers: [{color: "#334e87"}]
        }, {
          featureType: "landscape.natural",
          elementType: "geometry",
          stylers: [{color: "#023e58"}]
        }, {featureType: "poi", elementType: "geometry", stylers: [{color: "#283d6a"}]}, {
          featureType: "poi",
          elementType: "labels.text.fill",
          stylers: [{color: "#6f9ba5"}]
        }, {
          featureType: "poi",
          elementType: "labels.text.stroke",
          stylers: [{color: "#1d2c4d"}]
        }, {
          featureType: "poi.park",
          elementType: "geometry.fill",
          stylers: [{color: "#023e58"}]
        }, {
          featureType: "poi.park",
          elementType: "labels.text.fill",
          stylers: [{color: "#3C7680"}]
        }, {featureType: "road", elementType: "geometry", stylers: [{color: "#304a7d"}]}, {
          featureType: "road",
          elementType: "labels.text.fill",
          stylers: [{color: "#98a5be"}]
        }, {
          featureType: "road",
          elementType: "labels.text.stroke",
          stylers: [{color: "#1d2c4d"}]
        }, {
          featureType: "road.highway",
          elementType: "geometry",
          stylers: [{color: "#2c6675"}]
        }, {
          featureType: "road.highway",
          elementType: "geometry.stroke",
          stylers: [{color: "#255763"}]
        }, {
          featureType: "road.highway",
          elementType: "labels.text.fill",
          stylers: [{color: "#b0d5ce"}]
        }, {
          featureType: "road.highway",
          elementType: "labels.text.stroke",
          stylers: [{color: "#023e58"}]
        }, {
          featureType: "transit",
          elementType: "labels.text.fill",
          stylers: [{color: "#98a5be"}]
        }, {
          featureType: "transit",
          elementType: "labels.text.stroke",
          stylers: [{color: "#1d2c4d"}]
        }, {
          featureType: "transit.line",
          elementType: "geometry.fill",
          stylers: [{color: "#283d6a"}]
        }, {
          featureType: "transit.station",
          elementType: "geometry",
          stylers: [{color: "#3a4762"}]
        }, {featureType: "water", elementType: "geometry", stylers: [{color: "#0e1626"}]}, {
          featureType: "water",
          elementType: "labels.text.fill",
          stylers: [{color: "#4e6d70"}]
        }]
      }
    }, t.apiStatus = null, this.geolocate = function (t) {
      var i = e.Deferred(), s = new google.maps.Geocoder, o = t.data("address-setting");
      return s.geocode({address: o}, (function (e, t) {
        t !== google.maps.GeocoderStatus.OK && i.reject(t), i.resolve(e)
      })), i
    }, this.createMap = function (i) {
      var s = e(".map-section__map-container", i);
      return t.geolocate(s).then(function (o) {
        var n = {
          zoom: t.config.zoom,
          styles: t.config.styles[e(i).data("map-style")],
          center: o[0].geometry.location,
          scrollwheel: !1,
          disableDoubleClickZoom: !0,
          disableDefaultUI: !0,
          zoomControl: !s.data("hide-zoom")
        };
        t.map = new google.maps.Map(s[0], n), t.center = t.map.getCenter(), new google.maps.Marker({
          map: t.map,
          position: t.center,
          clickable: !1
        }), google.maps.event.addDomListener(window, "resize", (function () {
          google.maps.event.trigger(t.map, "resize"), t.map.setCenter(t.center)
        }))
      }.bind(this)).fail((function () {
        var e;
        switch (status) {
          case"ZERO_RESULTS":
            e = theme.strings.addressNoResults;
            break;
          case"OVER_QUERY_LIMIT":
            e = theme.strings.addressQueryLimit;
            break;
          default:
            e = theme.strings.addressError
        }
        if (Shopify.designMode) {
          var t = s.parents(".map-section");
          t.addClass("page-width map-section--load-error"), t.find(".map-section__wrapper").html('<div class="errors text-center">' + e + "</div>")
        }
      }))
    }, this.onSectionLoad = function (i) {
      var s = e(i);
      window.gm_authFailure = function () {
        Shopify.designMode && (s.addClass("page-width map-section--load-error"), s.find(".map-section__wrapper").html('<div class="errors text-center">' + theme.strings.authError + "</div>"))
      };
      var o = s.data("api-key");
      "string" == typeof o && "" !== o && theme.loadScriptOnce("https://maps.googleapis.com/maps/api/js?key=" + o, (function () {
        t.createMap(s)
      }))
    }, this.onSectionUnload = function (e) {
      void 0 !== window.google && void 0 !== google.maps && google.maps.event.clearListeners(t.map, "resize")
    }
  }, n.sections.push({name: "map", section: theme.MapSection}), theme.VideoManager = new function () {
    var t = this;
    t.videos = {incrementor: 0, videoData: {}}, t._loadYoutubeVideos = function (i) {
      e('.video-container[data-video-type="youtube"]:not(.video--init)', i).each((function () {
        e(this).addClass("video--init"), t.videos.incrementor++;
        var i = "theme-yt-video-" + t.videos.incrementor;
        e(this).data("video-container-id", i);
        var s = e(this).data("video-autoplay"), o = e(this).data("video-loop"), n = e(this).data("video-id"),
          a = e(this).hasClass("video-container--background"),
          r = new URLSearchParams("iv_load_policy=3&modestbranding=1&rel=0&showinfo=0&enablejsapi=1&playslinline=1");
        r.append("origin", location.origin), r.append("playlist", n), r.append("loop", o ? 1 : 0), r.append("autoplay", 0), r.append("controls", a ? 0 : 1);
        var c = t.videos.incrementor;
        r.append("widgetid", c);
        var l = "https://www.youtube.com/embed/" + n + "?" + r.toString(),
          d = e('<iframe class="video-container__video-element" frameborder="0" allowfullscreen="1" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture">').attr({
            id: i,
            width: 640,
            height: 360,
            tabindex: a ? "-1" : null
          }).appendTo(e(".video-container__video", this));
        t.videos.videoData[i] = {
          type: "yt",
          id: i,
          container: this,
          mute: () => d[0].contentWindow.postMessage('{"event":"command","func":"mute","args":""}', "*"),
          play: () => d[0].contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', "*"),
          pause: () => d[0].contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*"),
          stop: () => d[0].contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', "*"),
          seekTo: e => d[0].contentWindow.postMessage('{"event":"command","func":"seekTo","args":'.concat(e, "}"), "*"),
          videoElement: d[0],
          isBackgroundVideo: a,
          establishedYTComms: !1
        }, s && d.on("load", (() => setTimeout((() => {
          window.addEventListener("message", (s => {
            if ("https://www.youtube.com" === s.origin && s.data && "string" == typeof s.data) {
              var n = JSON.parse(s.data);
              "initialDelivery" === n.event && n.info && n.info.duration && (t.videos.videoData[i].duration = n.info.duration), "infoDelivery" === n.event && "widget" === n.channel && n.id === c && (t.videos.videoData[i].establishedYTComms = !0, n.info && 1 === n.info.playerState && e(this).addClass("video-container--playing"), o && n.info && n.info.currentTime > t.videos.videoData[i].duration - 1 && t.videos.videoData[i].seekTo(0))
            }
          })), d[0].contentWindow.postMessage('{"event":"listening","id":'.concat(c, ',"channel":"widget"}'), "*"), t.videos.videoData[i].mute(), t.videos.videoData[i].play(), setTimeout((() => {
            t.videos.videoData[i].establishedYTComms || e(this).addClass("video-container--playing")
          }), 2e3)
        }), 100))), a && (d.attr("tabindex", "-1"), t._initBackgroundVideo(t.videos.videoData[i]), t.addYTPageshowListenerHack()), d.attr("src", l), fetch("https://www.youtube.com/oembed?format=json&url=" + encodeURIComponent(e(this).data("video-url"))).then((e => {
          if (!e.ok) throw Error("HTTP error! Status: ".concat(e.status));
          return e.json()
        })).then((e => {
          e.width && e.height && (d.attr({
            width: e.width,
            height: e.height
          }), t.videos.videoData[i].assessBackgroundVideo && t.videos.videoData[i].assessBackgroundVideo())
        }))
      }))
    }, t._loadVimeoVideos = function (i) {
      e('.video-container[data-video-type="vimeo"]:not(.video--init)', i).each((function () {
        e(this).addClass("video--init"), t.videos.incrementor++;
        var i = "theme-vi-video-" + t.videos.incrementor;
        e(this).data("video-container-id", i);
        var s = e(this).data("video-autoplay"), o = e(this).data("video-loop"), n = e(this).data("video-id"),
          a = e(this).hasClass("video-container--background"), r = new URLSearchParams;
        s && r.append("muted", 1), o && r.append("loop", 1), a && r.append("controls", 0);
        var c = "https://player.vimeo.com/video/" + n + "?" + r.toString(),
          l = e('<iframe class="video-container__video-element" frameborder="0" allowfullscreen="1" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture">').attr({
            id: i,
            width: 640,
            height: 360,
            tabindex: a ? "-1" : null
          }).appendTo(e(".video-container__video", this));
        t.videos.videoData[i] = {
          type: "vimeo",
          id: i,
          container: this,
          play: () => l[0].contentWindow.postMessage('{"method":"play"}', "*"),
          pause: () => l[0].contentWindow.postMessage('{"method":"pause"}', "*"),
          videoElement: l[0],
          isBackgroundVideo: a,
          establishedVimeoComms: !1
        }, s && l.on("load", (() => setTimeout((() => {
          window.addEventListener("message", (s => {
            if ("https://player.vimeo.com" === s.origin && s.source === l[0].contentWindow && s.data) {
              var o = s.data;
              "string" == typeof o && (o = JSON.parse(o)), ("ping" === o.method || "playing" === o.event) && (t.videos.videoData[i].establishedVimeoComms = !0), "playing" === o.event && e(this).addClass("video-container--playing")
            }
          })), l[0].contentWindow.postMessage({
            method: "addEventListener",
            value: "playing"
          }, "*"), l[0].contentWindow.postMessage({
            method: "appendVideoMetadata",
            value: location.origin
          }, "*"), l[0].contentWindow.postMessage({method: "ping"}, "*"), t.videos.videoData[i].play(), setTimeout((() => {
            t.videos.videoData[i].establishedVimeoComms || e(this).addClass("video-container--playing")
          }), 2e3)
        }), 100))), a && (l.attr("tabindex", "-1"), t._initBackgroundVideo(t.videos.videoData[i])), l.attr("src", c), fetch("https://vimeo.com/api/oembed.json?url=" + encodeURIComponent(e(this).data("video-url"))).then((e => {
          if (!e.ok) throw Error("HTTP error! Status: ".concat(e.status));
          return e.json()
        })).then((e => {
          e.width && e.height && (l.attr({
            width: e.width,
            height: e.height
          }), t.videos.videoData[i].assessBackgroundVideo && t.videos.videoData[i].assessBackgroundVideo())
        }))
      }))
    }, t._loadMp4Videos = function (i) {
      e('.video-container[data-video-type="mp4"]:not(.video--init)', i).addClass("video--init").each((function () {
        t.videos.incrementor++;
        var s = "theme-mp-video-" + t.videos.incrementor, o = e(this);
        e(this).data("video-container-id", s);
        var n = e('<div class="video-container__video-element">').attr("id", s).appendTo(e(".video-container__video", this)),
          a = e(this).data("video-autoplay"), r = e(this).hasClass("video-container--background"),
          c = e("<video playsinline>");
        e(this).data("video-loop") && c.attr("loop", "loop"), c.on("click mouseenter", (() => c.attr("controls", "controls"))), a && (c.attr({
          autoplay: "autoplay",
          muted: "muted"
        }), c[0].muted = !0, c.one("loadeddata", (function () {
          this.play(), o.addClass("video-container--playing")
        }))), c.attr("src", e(this).data("video-url")).appendTo(n);
        var l = t.videos.videoData[s] = {
          type: "mp4",
          element: c[0],
          play: () => c[0].play(),
          pause: () => c[0].pause(),
          isBackgroundVideo: r
        };
        r && (c.attr("tabindex", "-1"), a && i.addEventListener("click", l.play, {once: !0}))
      }))
    }, t._initBackgroundVideo = function (t) {
      t.container.classList.contains("video-container--background") && (t.assessBackgroundVideo = function () {
        var e = this.offsetWidth, t = this.offsetHeight, i = this.querySelector("iframe"),
          s = parseFloat(i.width) / parseFloat(i.height), o = this.querySelector(".video-container__video");
        if (e / t > s) {
          var n = e / s + 150;
          o.style.marginTop = (t - n) / 2 - 75 + "px", o.style.marginInlineStart = "", o.style.height = n + 150 + "px", o.style.width = ""
        } else {
          var a = t + 150, r = a * s;
          o.style.marginTop = "-75px", o.style.marginInlineStart = (e - r) / 2 + "px", o.style.height = a + "px", o.style.width = r + "px"
        }
      }.bind(t.container), t.assessBackgroundVideo(), e(window).on("debouncedresize." + t.id, t.assessBackgroundVideo), t.container.addEventListener("click", t.play, {once: !0}))
    }, t._unloadVideos = function (i) {
      for (var s in t.videos.videoData) {
        var o = t.videos.videoData[s];
        if (e(i).find(o.container).length) return void delete t.videos.videoData[s]
      }
    }, this.onSectionLoad = function (i) {
      e(".video-container[data-video-url]:not([data-video-type])").each((function () {
        var t = e(this).data("video-url");
        t.indexOf(".mp4") > -1 && e(this).attr("data-video-type", "mp4"), t.indexOf("vimeo.com") > -1 && (e(this).attr("data-video-type", "vimeo"), e(this).attr("data-video-id", t.split("?")[0].split("/").pop())), (t.indexOf("youtu.be") > -1 || t.indexOf("youtube.com") > -1) && (e(this).attr("data-video-type", "youtube"), t.indexOf("v=") > -1 ? e(this).attr("data-video-id", t.split("v=").pop().split("&")[0]) : e(this).attr("data-video-id", t.split("?")[0].split("/").pop()))
      })), t._loadYoutubeVideos(i), t._loadVimeoVideos(i), t._loadMp4Videos(i), e(".video-container__play", i).on("click", (function (i) {
        i.preventDefault();
        var s = e(this).closest(".video-container");
        s.addClass("video-container--playing"), s.trigger("cc:video:play");
        var o = s.data("video-container-id");
        t.videos.videoData[o].play()
      })), e(".video-container__stop", i).on("click", (function (i) {
        i.preventDefault();
        var s = e(this).closest(".video-container");
        s.removeClass("video-container--playing"), s.trigger("cc:video:stop");
        var o = s.data("video-container-id");
        t.videos.videoData[o].pause()
      }))
    }, this.onSectionUnload = function (i) {
      e(".video-container__play, .video-container__stop", i).off("click"), e(window).off("." + e(".video-container").data("video-container-id")), e(window).off("debouncedresize.video-manager-resize"), t._unloadVideos(i), e(i).trigger("cc:video:stop")
    }, t.addYTPageshowListenerHack = function () {
      t.pageshowListenerAdded || (t.pageshowListenerAdded = !0, window.addEventListener("pageshow", (e => {
        e.persisted && Object.keys(t.videos.videoData).filter((e => "yt" === t.videos.videoData[e].type && t.videos.videoData[e].isBackgroundVideo)).forEach((e => {
          t.videos.videoData[e].stop(), t.videos.videoData[e].play()
        }))
      })))
    }
  }, n.sections.push({name: "video", section: theme.VideoManager}), theme.StoreAvailability = function (t) {
    var i = "store-availability-loading", s = "cc-location";
    this.onSectionLoad = function (t) {
      this.namespace = theme.namespaceFromSection(t), this.$container = e(t), this.productId = this.$container.data("store-availability-container"), this.sectionUrl = this.$container.data("section-url"), this.$modal, this.$container.addClass("store-availability-initialized"), this.transitionDurationMS = 1e3 * parseFloat(getComputedStyle(t).transitionDuration), this.removeFixedHeightTimeout = -1, e(window).on("cc-variant-updated".concat(this.namespace).concat(this.productId), ((e, t) => {
        t.product.id === this.productId && this.functions.updateContent.bind(this)(t.variant ? t.variant.id : null, t.product.title, this.$container.data("has-only-default-variant"), t.variant && void 0 !== t.variant.available)
      })), this.$container.data("single-variant-id") && this.functions.updateContent.bind(this)(this.$container.data("single-variant-id"), this.$container.data("single-variant-product-title"), this.$container.data("has-only-default-variant"), this.$container.data("single-variant-product-available"))
    }, this.onSectionUnload = function () {
      e(window).off("cc-variant-updated".concat(this.namespace).concat(this.productId)), this.$container.off("click"), this.$modal && this.$modal.off("click")
    }, this.functions = {
      getUserLocation: function () {
        return new Promise(((e, t) => {
          var i;
          sessionStorage[s] && (i = JSON.parse(sessionStorage[s])), i ? e(i) : navigator.geolocation ? navigator.geolocation.getCurrentPosition((function (t) {
            var i = {latitude: t.coords.latitude, longitude: t.coords.longitude};
            fetch("/localization.json", {
              method: "PUT",
              headers: {"Content-Type": "application/json"},
              body: JSON.stringify(i)
            }), sessionStorage[s] = JSON.stringify(i), e(i)
          }), (function () {
            e(!1)
          }), {maximumAge: 36e5, timeout: 5e3}) : e(!1)
        }))
      }, getAvailableStores: function (t, i) {
        return e.get(this.sectionUrl.replace("VARIANT_ID", t), i)
      }, calculateDistance: function (e, t, i) {
        var s = Math.PI / 180, o = e.latitude * s, n = e.longitude * s, a = t.latitude * s,
          r = Math.pow(Math.sin((o - a) / 2), 2) + Math.cos(o) * Math.cos(a) * Math.pow(Math.sin((n - t.longitude * s) / 2), 2);
        return ("metric" === i ? 6378.14 : 3959) * (2 * Math.atan2(Math.sqrt(r), Math.sqrt(1 - r)))
      }, updateLocationDistances: function (t) {
        var i = this.$modal.find("[data-unit-system]").data("unit-system"), s = this;
        this.$modal.find('[data-distance="false"]').each((function () {
          var o = {latitude: parseFloat(e(this).data("latitude")), longitude: parseFloat(e(this).data("longitude"))};
          if (o.latitude && o.longitude) {
            var n = s.functions.calculateDistance(t, o, i).toFixed(1);
            e(this).html(n), setTimeout((() => {
              e(this).closest(".store-availability-list__location__distance").addClass("-in")
            }), 0)
          }
          e(this).attr("data-distance", "true")
        }))
      }, updateContent: function (t, s, o, n) {
        this.$container.off("click", "[data-store-availability-modal-open]"), this.$container.off("click" + this.namespace, ".cc-popup-close, .cc-popup-background"), e(".store-availabilities-modal").remove(), n ? (this.$container.addClass(i), this.transitionDurationMS > 0 && this.$container.css("height", this.$container.outerHeight() + "px")) : (this.$container.addClass(i), this.transitionDurationMS > 0 && this.$container.css("height", "0px")), n && this.functions.getAvailableStores.call(this, t, (n => {
          if (n.trim().length > 0 && !n.includes("NO_PICKUP")) {
            this.$container.html(n), this.$container.html(this.$container.children().first().html()), this.$container.find("[data-store-availability-modal-product-title]").html(s), o && this.$container.find(".store-availabilities-modal__variant-title").remove(), this.$container.find(".cc-popup").appendTo("body"), this.$modal = e("body").find(".store-availabilities-modal");
            var a = new d(this.$modal, this.namespace);
            if (this.$container.on("click", "[data-store-availability-modal-open]", (() => (a.open(), this.functions.getUserLocation().then((i => {
              i && this.$modal.find('[data-distance="false"]').length && this.functions.getAvailableStores.call(this, t, (t => {
                this.$modal.find(".store-availabilities-list").html(e(t).find(".store-availabilities-list").html()), this.functions.updateLocationDistances.bind(this)(i)
              }))
            })), !1))), this.$modal.on("click" + this.namespace, ".cc-popup-close, .cc-popup-background", (() => {
              a.close()
            })), this.$container.removeClass(i), this.transitionDurationMS > 0) {
              var r = this.$container.find(".store-availability-container").outerHeight();
              this.$container.css("height", r > 0 ? r + "px" : ""), clearTimeout(this.removeFixedHeightTimeout), this.removeFixedHeightTimeout = setTimeout((() => {
                this.$container.css("height", "")
              }), this.transitionDurationMS)
            }
          }
        }))
      }
    }, this.onSectionLoad(t)
  }, n.sections.push({name: "store-availability", section: theme.StoreAvailability}), theme.Popup = new function () {
    var t = "cc-theme-popup-dismissed";
    this.onSectionLoad = function (i) {
      this.namespace = theme.namespaceFromSection(i), this.$container = e(i), this.popup = new d(this.$container, this.namespace);
      var s = this.$container.data("dismiss-for-days"), o = this.$container.data("delay-seconds"), n = !0,
        a = this.$container.data("test-mode"), r = window.localStorage.getItem(t);
      r && ((new Date).getTime() - r) / 864e5 < s && (n = !1), this.$container.find(".cc-popup-form__response").length && (n = !0, o = 1, this.$container.find(".cc-popup-form__response--success").length && this.functions.popupSetAsDismissed.call(this)), document.querySelector(".shopify-challenge__container") && (n = !1), (n || a) && setTimeout((() => {
        this.popup.open()
      }), 1e3 * o), this.$container.on("click" + this.namespace, ".cc-popup-close, .cc-popup-background", (() => {
        this.popup.close((() => {
          this.functions.popupSetAsDismissed.call(this)
        }))
      }))
    }, this.onSectionSelect = function () {
      this.popup.open()
    }, this.functions = {
      popupSetAsDismissed: function () {
        window.localStorage.setItem(t, (new Date).getTime())
      }
    }, this.onSectionUnload = function () {
      this.$container.off(this.namespace)
    }
  }, n.sections.push({name: "newsletter-popup", section: theme.Popup});
  try {
    theme.shopifyFeatures = JSON.parse(document.documentElement.querySelector("#shopify-features").textContent)
  } catch (e) {
    theme.shopifyFeatures = {}
  }
  slate.a11y = {
    pageLinkFocus: function (e) {
      var t = "js-focus-hidden";
      e.first().attr("tabIndex", "-1").focus().addClass(t).one("blur", (function () {
        e.first().removeClass(t).removeAttr("tabindex")
      }))
    }, focusHash: function () {
      var t = window.location.hash;
      t && document.getElementById(t.slice(1)) && this.pageLinkFocus(e(t))
    }, bindInPageLinks: function () {
      e("a[href*=#]").on("click", function (t) {
        this.pageLinkFocus(e(t.currentTarget.hash))
      }.bind(this))
    }, trapFocus: function (t) {
      var i = t.namespace ? "focusin." + t.namespace : "focusin";
      t.$elementToFocus || (t.$elementToFocus = t.$container), t.$container.attr("tabindex", "-1"), t.$elementToFocus.focus(), e(document).on(i, (function (e) {
        t.$container[0] === e.target || t.$container.has(e.target).length || t.$container.focus()
      }))
    }, removeTrapFocus: function (t) {
      var i = t.namespace ? "focusin." + t.namespace : "focusin";
      t.$container && t.$container.length && t.$container.removeAttr("tabindex"), e(document).off(i)
    }
  }, slate.cart = {
    cookiesEnabled: function () {
      var e = navigator.cookieEnabled;
      return e || (document.cookie = "testcookie", e = -1 !== document.cookie.indexOf("testcookie")), e
    }
  }, slate.utils = {
    findInstance: function (e, t, i) {
      for (var s = 0; s < e.length; s++) if (e[s][t] === i) return e[s]
    }, removeInstance: function (e, t, i) {
      for (var s = e.length; s--;) if (e[s][t] === i) {
        e.splice(s, 1);
        break
      }
      return e
    }, compact: function (e) {
      for (var t = -1, i = null == e ? 0 : e.length, s = 0, o = []; ++t < i;) {
        var n = e[t];
        n && (o[s++] = n)
      }
      return o
    }, defaultTo: function (e, t) {
      return null == e || e != e ? t : e
    }
  }, slate.rte = {
    wrapTable: function (e) {
      var t = void 0 === e.tableWrapperClass ? "" : e.tableWrapperClass;
      e.$tables.wrap('<div class="' + t + '"></div>')
    }, wrapIframe: function (t) {
      var i = void 0 === t.iframeWrapperClass ? "" : t.iframeWrapperClass;
      t.$iframes.each((function () {
        e(this).wrap('<div class="' + i + '"></div>'), this.src = this.src
      }))
    }
  }, slate.Image = {
    preload: function (e, t) {
      "string" == typeof e && (e = [e]);
      for (var i = 0; i < e.length; i++) {
        var s = e[i];
        this.loadImage(this.getSizedImageUrl(s, t))
      }
    }, loadImage: function (e) {
      (new Image).src = e
    }, imageSize: function (e) {
      var t = e.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);
      return t ? t[1] : null
    }, getSizedImageUrl: function (e, t) {
      if (null === t) return e;
      if ("master" === t) return this.removeProtocol(e);
      var i = e.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
      if (!i) return null;
      var s = e.split(i[0]), o = i[0];
      return this.removeProtocol(s[0] + "_" + t + o)
    }, removeProtocol: function (e) {
      return e.replace(/http(s)?:/, "")
    }
  }, slate.Variants = function () {
    function t(t) {
      this.$container = t.$container, this.product = t.product, this.singleOptionSelector = t.singleOptionSelector, this.originalSelectorId = t.originalSelectorId, this.secondaryIdSelectors = t.secondaryIdSelectors, this.enableHistoryState = t.enableHistoryState, this.currentVariant = this._getVariantFromOptions(), this._updateQtySelector(this.currentVariant), e(this.singleOptionSelector, this.$container).on("change", this._onSelectChange.bind(this))
    }

    return t.prototype = e.extend({}, t.prototype, {
      _getCurrentOptions: function () {
        return e.map(e(this.singleOptionSelector, this.$container), (function (e) {
          var t = {};
          if ("listed" === e.dataset.selectorType) {
            var i = e.querySelector("input:checked");
            return !!i && (t.value = i.value, t.index = e.dataset.index, t)
          }
          var s = e.querySelector('[aria-selected="true"]');
          return !!s && (t.value = s.dataset.value, t.index = e.dataset.index, t)
        }))
      }, _getVariantFromOptions: function () {
        var e = this._getCurrentOptions(), t = this.product.variants, i = !1;
        return t.forEach((function (t) {
          var s = !0;
          e.forEach((function (e) {
            s && (s = e.value === t[e.index])
          })), s && (i = t)
        })), i || null
      }, _getVariantOptionElement: function (e) {
        return this.$container.find('select[name="id"] option[value="' + e.id + '"]')
      }, _onSelectChange: function () {
        var t = this._getVariantFromOptions();
        this.$container.trigger({
          type: "variantChange",
          variant: t
        }), this._updateSecondarySelects(t), this._updateInventoryNotice(t), this._updateQtySelector(t), t && (e(window).trigger("cc-variant-updated", {
          variant: t,
          product: this.product
        }), this._updateMasterSelect(t), this._updateImages(t), this._updatePrice(t), this.currentVariant = t, this.enableHistoryState && this._updateHistoryState(t))
      }, _updateImages: function (e) {
        var t = e.featured_media || {}, i = this.currentVariant.featured_media || {};
        e.featured_media && t.id !== i.id && this.$container.trigger({type: "variantImageChange", variant: e})
      }, _updatePrice: function (e) {
        var t = !1;
        (e.price !== this.currentVariant.price || e.compare_at_price !== this.currentVariant.compare_at_price || e.unit_price_measurement !== this.currentVariant.unit_price_measurement || e.unit_price_measurement && (e.unit_price !== this.currentVariant.unit_price || e.unit_price_measurement.reference_value !== this.currentVariant.unit_price_measurement.reference_value || e.unit_price_measurement.reference_unit !== this.currentVariant.unit_price_measurement.reference_unit)) && (t = !0), t && this.$container.trigger({
          type: "variantPriceChange",
          variant: e
        })
      }, _updateInventoryNotice: function (e) {
        var t = document.querySelector(".product-inventory");
        if (t) {
          var i = () => {
            t.classList.remove("product-inventory--low"), t.classList.add("product-inventory--none"), t.innerHTML = ""
          };
          if (!e) return void i();
          var s = this._getVariantOptionElement(e);
          if ("out" === s[0].dataset.stock) i(); else {
            var {showNotice: o, showCount: n} = t.dataset, a = Number(s[0].dataset.inventory),
              r = a && a <= Number(t.dataset.threshold);
            if ("low" === o && !r) return void i();
            var c = r ? theme.strings.low_stock : theme.strings.in_stock, l = "";
            ("always" === n || "low" === n && r) && (l = " - ".concat(1 === a ? theme.strings.single_unit_available : theme.strings.x_units_available.replace("[[ quantity ]]", a))), t.classList.remove("product-inventory--none"), t.classList.toggle("product-inventory--low", r), t.innerHTML = '<span class="product-inventory__status">'.concat(c, "</span>").concat(l)
          }
        }
      }, _updateQtySelector: function (e) {
        var t = this.$container[0].querySelector(".qty-wrapper");
        if (t) {
          if (!e || !e.available) return void t.classList.add("is-disabled");
          var i = Number(this._getVariantOptionElement(e)[0].dataset.inventory),
            s = t.querySelectorAll(".cc-select__option"), o = theme.settings.dynamicQtyOpts && i && i > 0 && i < 10;
          s.forEach(((e, t) => {
            e.hidden = o && t + 1 > i
          })), t.classList.remove("is-disabled")
        }
      }, _updateHistoryState: function (e) {
        if (history.replaceState && e) {
          var t = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + e.id;
          window.history.replaceState({path: t}, "", t)
        }
      }, _updateMasterSelect: function (t) {
        var i = e(this.originalSelectorId, this.$container)[0];
        i && (i.value = t.id, i.dispatchEvent(new Event("change", {bubbles: !0, cancelable: !1})))
      }, _updateSecondarySelects: function (t) {
        e(this.secondaryIdSelectors, this.$container).each((function () {
          this.value = t ? t.id : null, this.dispatchEvent(new Event("change", {bubbles: !0, cancelable: !1}))
        }))
      }
    }), t
  }();
  var h, u = class extends HTMLElement {
    connectedCallback() {
      fetch(this.dataset.url).then((e => {
        if (!e.ok) throw Error("HTTP error! Status: ".concat(e.status));
        return e.text()
      })).then((t => {
        var i = document.createDocumentFragment(), s = document.createElement("div");
        i.appendChild(s), s.innerHTML = t;
        var o = s.querySelector('[data-id="'.concat(CSS.escape(this.dataset.id), '"]'));
        o && (this.innerHTML = o.innerHTML, this.hasAttribute("contains-product-blocks") && e(".js-content-products-slider .grid", this).each((function (t, i) {
          var s = i.closest("[data-section-type]");
          theme.peekCarousel.init(e(s), e(i), s.dataset.sectionId, (function () {
            return !0
          }), !1, {
            infinite: !1,
            slidesToShow: 2,
            slidesToScroll: 1,
            swipeToSlide: !0,
            dots: !1,
            prevArrow: e(i).closest(".content-products").find(".content-products-controls .prev"),
            nextArrow: e(i).closest(".content-products").find(".content-products-controls .next"),
            responsive: [{breakpoint: 960, settings: {slidesToShow: 1}}]
          })
        })))
      }))
    }
  };
  window.customElements.define("cc-fetched-content", u), theme.storageAvailable = function (e) {
    try {
      var t = window[e], i = "__storage_test__";
      return t.setItem(i, i), t.removeItem(i), !0
    } catch (e) {
      return e instanceof DOMException && (22 === e.code || 1014 === e.code || "QuotaExceededError" === e.name || "NS_ERROR_DOM_QUOTA_REACHED" === e.name) && 0 !== t.length
    }
  }, theme.variants = {
    selectors: {
      originalSelectorId: "[data-product-select]",
      secondaryIdSelectors: "[data-product-secondary-select]",
      priceWrapper: "[data-price-wrapper]",
      productPrice: "[data-product-price]",
      addToCart: "[data-add-to-cart]",
      addToCartText: "[data-add-to-cart-text]",
      comparePrice: "[data-compare-price]",
      comparePriceText: "[data-compare-text]",
      unitPrice: ".unit-price"
    }, getBaseUnit: function (e) {
      return 1 === e.unit_price_measurement.reference_value ? e.unit_price_measurement.reference_unit : e.unit_price_measurement.reference_value + e.unit_price_measurement.reference_unit
    }, updateAddToCartState: function (t) {
      var i = t.variant;
      if (!i) return e(theme.variants.selectors.addToCart, this.$container).prop("disabled", !0), e(theme.variants.selectors.addToCartText, this.$container).html(theme.strings.unavailable), void e(theme.variants.selectors.priceWrapper, this.$container).addClass("hide");
      e(theme.variants.selectors.priceWrapper, this.$container).removeClass("hide"), i.available ? (e(theme.variants.selectors.addToCart, this.$container).prop("disabled", !1), e(theme.variants.selectors.addToCartText, this.$container).html(theme.strings.addToCart), e("form", this.$container).removeClass("variant--unavailable")) : (e(theme.variants.selectors.addToCart, this.$container).prop("disabled", !0), e(theme.variants.selectors.addToCartText, this.$container).html(theme.strings.soldOut), e("form", this.$container).addClass("variant--unavailable"));
      var s = e(".backorder", this.$container);
      if (s.length) if (i && i.available) {
        var o = e(theme.variants.selectors.originalSelectorId + ' option[value="' + i.id + '"]', this.$container);
        i.inventory_management && "out" == o.data("stock") ? (s.find(".backorder__variant").html(this.productSingleObject.title + (i.title.indexOf("Default") >= 0 ? "" : " - " + i.title)), s.show()) : s.hide()
      } else s.hide()
    }, updateProductPrices: function (t) {
      var i = t.variant, s = e(theme.variants.selectors.comparePrice, this.$container),
        o = s.add(theme.variants.selectors.comparePriceText, this.$container),
        n = e(theme.variants.selectors.productPrice, this.$container),
        a = e(theme.variants.selectors.unitPrice, this.$container), r = n.is("[data-product-detail-price]");
      if (n.html('<span class="theme-money' + (r ? " large-title" : "") + '">' + theme.Shopify.formatMoney(i.price, theme.moneyFormatWithCodeForProductsPreference) + "</span>"), i.compare_at_price > i.price ? (n.addClass("product-price__reduced"), s.html('<span class="product-price__compare theme-money">' + theme.Shopify.formatMoney(i.compare_at_price, theme.moneyFormat) + "</span>"), o.removeClass("hide")) : (n.removeClass("product-price__reduced"), s.html(""), o.addClass("hide")), i.unit_price_measurement) {
        var c = e('<div class="unit-price small-text">');
        e('<span class="unit-price__price theme-money">').html(theme.Shopify.formatMoney(i.unit_price, theme.moneyFormat)).appendTo(c), e('<span class="unit-price__separator">').html(theme.strings.unitPriceSeparator).appendTo(c), e('<span class="unit-price__unit">').html(theme.variants.getBaseUnit(i)).appendTo(c), a.length ? a.replaceWith(c) : e(theme.variants.selectors.priceWrapper, this.$container).append(c)
      } else a.remove()
    }
  }, theme.initAjaxAddToCartForm = function (t) {
    t.on("submit", (function (t) {
      t.preventDefault();
      var i = e(this);
      i.addClass("add-in-progress").find(":submit").attr("disabled", "disabled").each((function () {
        var t = e(this).is("button") ? "html" : "val";
        e(this).data("previous-value", e(this)[t]())[t](theme.strings.addingToCart)
      })), e.post(theme.routes.cart_add_url + ".js", i.serialize(), (function (t) {
        i.find(":submit").each((function () {
          var t = e(this), s = e(this).is("button") ? "html" : "val";
          t[s](theme.strings.addedToCart), setTimeout((function () {
            t.removeAttr("disabled")[s](t.data("previous-value")), i.removeClass("add-in-progress")
          }), 1e3)
        })).first(), e.get(theme.routes.search_url, (function (t) {
          for (var i = [".page-header .header-cart", ".docked-navigation-container .header-cart"], s = e(e.parseHTML("<div>" + t + "</div>")), o = 0; o < i.length; o++) {
            var n = i[o], a = s.find(n).clone();
            e(n).replaceWith(a)
          }
        })), e.colorbox.close(), theme.productData = theme.productData || {}, theme.productData[t.product_id] || (theme.productData[t.product_id] = JSON.parse(document.querySelector(".ProductJson-" + t.product_id).innerHTML));
        for (var s, o = null, n = 0; n < theme.productData[t.product_id].variants.length; n++) {
          var a = theme.productData[t.product_id].variants[n];
          a.id == t.variant_id && (o = a)
        }
        var r = "";
        t.original_line_price > t.final_line_price ? (r += '<span class="cart-summary__price-reduced product-price__reduced theme-money">' + theme.Shopify.formatMoney(t.final_line_price, theme.moneyFormat) + "</span>", r += '<span class="cart-summary__price-compare product-price__compare theme-money">' + theme.Shopify.formatMoney(t.original_line_price, theme.moneyFormat) + "</span>") : r += '<span class="theme-money">' + theme.Shopify.formatMoney(t.final_line_price, theme.moneyFormat) + "</span>", t.unit_price && (r += '<span class="cart-summary__unit-price unit-price theme-money">' + theme.Shopify.formatMoney(t.unit_price, theme.moneyFormat) + theme.strings.unitPriceSeparator + t.unit_price_measurement.reference_unit + "</span>");
        var c = "";
        if (t.quantity > 1 && (c = ' <span class="cart-summary__quantity">' + t.quantity + "</span>"), t.line_level_discount_allocations && t.line_level_discount_allocations.length > 0) {
          r += '<ul class="cart-discount-list small-text">';
          for (n = 0; n < t.line_level_discount_allocations.length; n++) {
            var l = t.line_level_discount_allocations[n];
            r += ['<li class="cart-discount">', '<div class="cart-discount__label">', l.discount_application.title, "</div>", '<div class="cart-discount__amount theme-money">', theme.Shopify.formatMoney(l.amount, theme.moneyFormat), "</div>", "</li>"].join("")
          }
          r += "</ul>"
        }
        var d = "";
        t.selling_plan_allocation && t.selling_plan_allocation.selling_plan.name && (d = ['<div class="cart-summary__selling-plan ">', t.selling_plan_allocation.selling_plan.name, "</div>"].join(""));
        var h = "";
        if (o) {
          var u = theme.productData[t.product_id].options;
          h = '<div class="cart-summary__product__variants">';
          for (n = 0; n < o.options.length; n++) 0 > o.options[n].indexOf("Default Title") && (h += '<div class="cart-summary__variant">', h += '<span class="cart-summary__variant-label">' + u[n] + ":</span> ", h += '<span class="cart-summary__variant-value">' + o.options[n] + "</span>", h += "</div>");
          h += "</div>"
        }
        o.featured_media ? s = slate.Image.getSizedImageUrl(o.featured_media.preview_image.src, "200x") : theme.productData[t.product_id].media && theme.productData[t.product_id].media.length > 0 && (s = slate.Image.getSizedImageUrl(theme.productData[t.product_id].media[0].preview_image.src, "200x")), e.getJSON(theme.routes.cart_url + ".js", (function (i) {
          var o = e(['<div class="added-notice global-border-radius added-notice--pre-reveal">', '<div class="added-notice__header">', '<span class="added-notice__title">', theme.strings.addedToCartPopupTitle, "</span>", '<a class="added-notice__close feather-icon" href="#" aria-label="', theme.strings.close, '">', theme.icons.close, "</a>", "</div>", '<div class="added-notice-sub-heading">', "<span>Gefeliciteerd! Je hebt een top keuze gemaakt!🐶</span>", "</div>", '<div class="progress"><progress style="width:50%;height:8px;" max="10000" value="', theme.Shopify.formatMoney(i.total_price, theme.moneyFormatWithCodeForCartPreference), '"></progress> </div>', '<div class="cart-summary global-border-radius">', '<div class="cart-summary__product">', '<div class="cart-summary__product-image"><img class="global-border-radius" src="', s, '" role="presentation" alt=""></div>', '<div class="cart-summary__product__description">', '<div class="cart-summary__product-title">', theme.productData[t.product_id].title, c, "</div>", h, d, '<div class="cart-summary__price">', r, "</div>", "</div>", "</div>", "</div>", '<div class="cart-summary__footer">', '<div class="cart-summary__total-quantity-row">', "<span>", theme.strings.addedToCartPopupItems, "</span>", "<span>", i.item_count, "</span>", "</div>", '<div class="cart-summary__total-price-row large-text">', "<span>", theme.strings.addedToCartPopupSubtotal, "</span>", '<span class="theme-money">', theme.Shopify.formatMoney(i.total_price, theme.moneyFormatWithCodeForCartPreference), "</span>", "</div>", '<a href="', theme.routes.cart_url, '" class="btn btn--primary btn--small btn--fullwidth cart-summary__button">', theme.strings.addedToCartPopupGoToCart, "</a>", '<div class="payment-icons cart-pop">', '<ul class="inline-list">', '<li><img src="https://cdn.shopify.com/shopifycloud/web/assets/v1/11215ca3a53502f071f5ab47c6d7214d412822a6a0f226850809a045fa62fe60.svg"></li>', '<li><img src="https://cdn.shopify.com/shopifycloud/web/assets/v1/34fddffaedda55c4ef8a6e4fd64d63457f2567136f4f7b3f3df6b4a4b07b16f4.svg"></li>', '<li><img src="https://cdn.shopify.com/shopifycloud/web/assets/v1/3d2a88eeb1a07c936ee98255a22970e0aa03281f8603eec0bd5405e7fff1ec76.svg"></li>', '<li><img src="https://cdn.shopify.com/shopifycloud/web/assets/v1/da692be1019eb4c4ddd6777517a11962e75170d113b517a2eb76fefa97f4e620.svg"></li>', '<li><img src="https://cdn.shopify.com/shopifycloud/web/assets/v1/e5bb141b54e28209f7521e4fcaee8d5a9655d39f82c55bef1d7f62633b4388ba.svg"></li>', "</ul>", "</div>", "</div>", "</div>"].join(""));
          o.appendTo("body"), setTimeout((function () {
            o.removeClass("added-notice--pre-reveal")
          }), 10), theme.addedToCartNoticeHideTimeoutId = setTimeout((function () {
            o.find(".added-notice__close").trigger("click")
          }), 5e3)
        }))
      }), "json").fail((function (t) {
        i.removeClass("add-in-progress");
        var s = i.find(":submit").removeAttr("disabled").each((function () {
          var t = e(this);
          t[t.is("button") ? "html" : "val"](t.data("previous-value"))
        })).first();
        void 0 !== t && t.responseJSON && t.responseJSON.description ? theme.showQuickPopup(t.responseJSON.description, s) : i.off("submit").submit()
      }))
    })), e(document).off(".ajaxAddToCart"), e(document).on("click.ajaxAddToCart", ".added-notice__close", (function () {
      var t = e(this).closest(".added-notice").addClass("added-notice--pre-destroy");
      return setTimeout((function () {
        t.remove()
      }), 500), !1
    })), e(document).on("mouseenter.ajaxAddToCart", ".header-cart", (function () {
      clearTimeout(theme.addedToCartNoticeHideTimeoutId), e(".added-notice__close").trigger("click")
    }))
  }, theme.unloadAjaxAddToCartForm = function (e) {
    e.off("submit")
  }, e((function () {
    function t(e) {
      var t = {
        left: e.offset().left - parseFloat(e.css("margin-left")),
        top: e.offset().top - parseFloat(e.css("margin-top")),
        width: e.outerWidth(),
        height: e.outerHeight()
      };
      return t.right = t.left + t.width, t.bottom = t.top + t.height, e.hasClass("avoid-overlaps__item--gravity-left") ? t.gravity = 0 : e.hasClass("avoid-overlaps__item--gravity-right") ? t.gravity = 2 : t.gravity = 1, t
    }

    function i(e) {
      0 == e.newRect.gravity || (2 == e.newRect.gravity ? (e.newRect.right = e.newRect.left, e.newRect.left = e.newRect.right - e.newRect.width) : (e.newRect.left = e.newRect.left - e.newRect.width / 2, e.newRect.right = e.newRect.left + e.newRect.width)), e.newRect.top = e.newRect.top - e.newRect.height / 2, e.newRect.bottom = e.newRect.top + e.newRect.height
    }

    function s(e, t) {
      e.newRect.left < t.left + 10 && (e.newRect.left = t.left + 11, e.newRect.right = e.newRect.left + e.newRect.width), e.newRect.top < t.top + 10 && (e.newRect.top = t.top + 11, e.newRect.bottom = e.newRect.top + e.newRect.height), e.newRect.right > t.right - 10 && (e.newRect.right = t.right - 11, e.newRect.left = e.newRect.right - e.newRect.width), e.newRect.bottom > t.bottom - 10 && (e.newRect.bottom = t.bottom - 11, e.newRect.top = e.newRect.bottom - e.newRect.height)
    }

    function o(e, t) {
      return !(e.right < t.left || e.left > t.right || e.bottom < t.top || e.top > t.bottom)
    }

    function n(e, t) {
      return !(e.right + 10 < t.left || e.left - 10 > t.right || e.bottom + 10 < t.top || e.top - 10 > t.bottom)
    }

    function a(e, t) {
      var i = t.left + (t.right - t.left) / 2 - (e.left + (e.right - e.left) / 2),
        s = t.top + (t.bottom - t.top) / 2 - (e.top + (e.bottom - e.top) / 2);
      return Math.abs(i) > Math.abs(s) ? i > 0 ? [1, 0, 2, 3] : [3, 0, 2, 1] : s > 0 ? [2, 1, 3, 0] : [0, 1, 3, 2]
    }

    function r(t, i, s, n, a) {
      var r = e.extend({}, t.newRect);
      switch (i) {
        case 0:
          r.bottom = s.newRect.top - 11, r.top = r.bottom - r.height;
          break;
        case 1:
          r.left = s.newRect.right + 11, r.right = r.left + r.width;
          break;
        case 2:
          r.top = s.newRect.bottom + 11, r.bottom = r.top + r.height;
          break;
        case 3:
          r.right = s.newRect.left - 11, r.left = r.right - r.width
      }
      for (var c, l, d = (l = n, (c = r).left >= l.left + 10 && c.top >= l.top + 10 && c.right <= l.right - 10 && c.bottom <= l.bottom - 10), h = !1, u = 0; u < a.length; u++) {
        var p = a[u];
        p.el[0] != t.el[0] && o(r, p.newRect) && (h = !0)
      }
      return !!d && !h && (t.newRect = r, !0)
    }

    theme.checkOverlaps = function () {
      e(".avoid-overlaps").each((function () {
        var o, c = e(this), l = e(".avoid-overlaps__mobile-container", this);
        o = l.length && "relative" == l.css("position") ? t(l) : t(c);
        var d = e(this).find(".avoid-overlaps__item"), h = [], u = [], p = [];
        d.each((function () {
          var i = {el: e(this), newRect: t(e(this)), oldRect: t(e(this)), overlaps: !1};
          h.push(i), e(this).hasClass("overlay") || p.push(i), "absolute" != e(this).css("position") || e(this).hasClass("overlay--bottom-wide") || e(this).hasClass("overlay--low-wide") || u.push(i)
        }));
        for (var m = 0; m < u.length; m++) {
          i(f = u[m]), s(f, o)
        }
        for (m = 0; m < h.length; m++) for (var f = h[m], v = 0; v < p.length; v++) {
          var g = p[v];
          if (g.el[0] != f.el[0]) for (var y = a(f.newRect, g.newRect); y.length > 0 && n(f.newRect, g.newRect);) {
            var b = r(g, y.shift(), f, o, h);
            g.overlaps = !b
          }
        }
        for (v = 0; v < h.length; v++) {
          var w = h[v], _ = w.newRect.left - w.oldRect.left, k = w.newRect.top - w.oldRect.top;
          w.el.css({
            marginLeft: 0 != _ ? _ : "",
            marginTop: 0 != k ? k : ""
          }), w.el.toggleClass("is-overlapping", w.overlaps)
        }
      })).addClass("avoid-overlaps--processed")
    }, theme.checkOverlaps(), e(document).on("shopify:section:load", theme.checkOverlaps), e(window).on("debouncedresize", theme.checkOverlaps)
  })), theme.assessLoadedRTEImage = function (t) {
    var i = e(t).closest(".rte").width();
    if (e(t)[0].naturalWidth > i) {
      var s = e(t).parentsUntil(".rte").filter("p");
      s.length > 0 ? s.addClass("expanded-width") : e(t).wrap('<p class="expanded-width"></p>')
    } else e(t).closest(".expanded-width").removeClass("expanded-width")
  }, theme.assessRTEImagesOnLoad = function (t) {
    e(".rte--expanded-images img:not(.exp-loaded)", t).each((function () {
      var t = this, i = new Image;
      e(i).on("load.rteExpandedImage", (function () {
        e(t).addClass("exp-loaded"), theme.assessLoadedRTEImage(t)
      })), i.src = this.src, (i.complete || 4 === i.readyState) && (e(i).off("load.rteExpandedImage"), e(t).addClass("exp-loaded"), theme.assessLoadedRTEImage(t))
    }))
  }, theme.assessRTEImagesOnLoad(), e(window).on("debouncedresize", (function () {
    e(".rte--expanded-images img.exp-loaded").each((function () {
      theme.assessLoadedRTEImage(this)
    }))
  })), theme.recentProductCacheExpiry = 6e5, theme.recentProductHistoryCap = 12, theme.recentProductsStorageKey = "theme.recent_products_v3", theme.addRecentProduct = function (t, i, s, o, n) {
    var a = t[i], r = t, c = o, l = n, d = s,
      h = e('<div class="product-block product-block--recent-unloaded grid__item one-sixth medium--one-quarter small-down--one-whole">'),
      u = (new Date).getTime();
    a.timestamp && a.timestamp > u - theme.recentProductCacheExpiry ? h.append(theme.buildRecentProduct(a, c, l)).removeClass("product-block--recent-unloaded") : e.getJSON(a.url + ".js", (function (e) {
      a.title = e.title, a.image = e.media && e.media.length ? e.media[0].preview_image.src : "", a.timestamp = u, window.localStorage.setItem(theme.recentProductsStorageKey, JSON.stringify(r)), d.filter(".slick-initialized").slick("slickUnfilter"), h.append(theme.buildRecentProduct(a, c, l)).removeClass("product-block--recent-unloaded"), d.filter(".slick-initialized").slick("slickFilter", ":not(.product-block--recent-unloaded)")
    })), s.append(h), theme.assessRecentProductGrid(s)
  }, theme.assessRecentProductGrid = function (t) {
    var i = t.children(), s = Math.max(i.length - 4, 0);
    if (s > 0) {
      i.slice(0, 3).removeClass("medium--hide");
      for (var o = 0; o < s; o++) e(i[o]).addClass("medium--hide")
    }
  }, theme.onRecentProductImageLoad = function () {
  }, theme.buildRecentProduct = function (t, i, s) {
    var o = e('<a class="recently-viewed-product plain-link">').attr({href: t.url, title: t.title}),
      n = e('<div class="product-block__image-container">').appendTo(o),
      a = e('<div class="hover-images global-border-radius relative">').appendTo(n);
    return t.image && e('<div class="image-one">').append(e('<img role="presentation">').on("load", theme.onRecentProductImageLoad).attr({
      src: t.image,
      alt: t.title
    })).appendTo(a), i && t.image2 && (a.addClass("hover-images--two"), e('<div class="image-two">').css("background-image", "url(" + t.image2 + ")").appendTo(a)), !1 === t.available ? theme.settings.soldLabelEnabled && e('<span class="product-label product-label--sold-out global-border-radius"></span>').html(theme.strings.soldOut).appendTo(a) : theme.settings.saleLabelEnabled && t.compareAtPrice > t.price && e('<span class="product-label product-label--on-sale global-border-radius"></span>').html(theme.strings.onSale).appendTo(a), e('<div class="product-block__title small-text">').html(t.title).appendTo(o), s && e('<div class="product-block__vendor tiny-text">').html(t.vendor).appendTo(o), o
  }, theme.getRecentProducts = function () {
    var e = window.localStorage.getItem(theme.recentProductsStorageKey);
    if (e) try {
      return JSON.parse(e)
    } catch (e) {
    }
    return []
  }, theme.addToAndReturnRecentProducts = function (e) {
    for (var t = theme.getRecentProducts(), i = !0; i;) {
      i = !1;
      for (var s = 0; s < t.length; s++) if (t[s].handle == e.handle) {
        t.splice(s, 1), i = !0;
        break
      }
    }
    for (e.timestamp = (new Date).getTime(), t.push(e); t.length > theme.recentProductHistoryCap;) t.shift();
    return window.localStorage.setItem(theme.recentProductsStorageKey, JSON.stringify(t)), t
  }, theme.loadRecentlyViewed = function (t) {
    theme.peekCarousel.init(t, e(".grid", t), ".recentlyViewed", (function () {
      return 768 > e(window).width()
    })), e(".grid", t).filter(".slick-initialized").slick("slickFilter", ":not(.product-block--recent-unloaded)")
  }, theme.unloadRecentlyViewed = function (t) {
    theme.peekCarousel.destroy(t, e(".slick-initialized", t), ".recentlyViewed")
  }, theme.ProductMedia = new function () {
    var t = this;
    t._setupShopifyXr = function () {
      window.ShopifyXR ? (window.ShopifyXR.addModels(JSON.parse(e(this).html())), window.ShopifyXR.setupXRElements()) : document.addEventListener("shopify_xr_initialized", t._setupShopifyXr.bind(this))
    }, this.init = function (i, s) {
      s = s || {};
      var o = i;
      e(i).on("mediaVisible", ".product-media--video-loaded, .product-media--model-loaded", (function () {
        e(window).width() >= 768 && e(this).data("player").play(), e(this).hasClass("product-media--model") && e(".view-in-space", o).attr("data-shopify-model3d-id", e(this).data("model-id"))
      })), e(i).on("mediaHidden", ".product-media--video-loaded, .product-media--model-loaded", (function () {
        e(this).data("player").pause()
      })), s.onVideoVisible && e(i).on("mediaVisible", ".product-media--video-loaded", s.onVideoVisible), s.onVideoHidden && e(i).on("mediaHidden", ".product-media--video-loaded", s.onVideoHidden), e("model-viewer", i).each((function () {
        s.onModelViewerPlay && e(this).on("shopify_model_viewer_ui_toggle_play", s.onModelViewerPlay), s.onModelViewerPause && e(this).on("shopify_model_viewer_ui_toggle_pause", s.onModelViewerPause)
      })), e(i).find(".product-media--video").each((function (t) {
        var i = e(this).data("enable-video-looping"), o = e(this).find("iframe, video")[0], n = e(this);
        if ("VIDEO" === o.tagName) window.Shopify.loadFeatures([{
          name: "video-ui", version: "1.0", onLoad: function () {
            var t = {playerType: "html5", element: o};
            t.play = function () {
              this.plyr.play()
            }.bind(t), t.pause = function () {
              this.plyr.pause()
            }.bind(t), t.destroy = function () {
              this.plyr.destroy()
            }.bind(t), t.plyr = new Shopify.Plyr(o, {
              controls: ["play", "progress", "mute", "volume", "play-large", "fullscreen"],
              loop: {active: i},
              hideControlsOnPause: !0,
              iconUrl: "//cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.svg",
              tooltips: {controls: !1, seek: !0}
            }), e(this).data("player", t).addClass("product-media--video-loaded"), e(o).on("playing", (function () {
              e(".product-media").not(n).trigger("mediaHidden"), n.find(".plyr__controls").off(".themeMediaEventFix").on("keydown.themeMediaEventFix touchstart.themeMediaEventFix mousedown.themeMediaEventFix keydown.themeMediaEventFix", (function (e) {
                e.stopPropagation()
              })), s.onPlyrPlay && s.onPlyrPlay(t)
            })), e(o).on("pause ended", (function () {
              n.find(".plyr__controls").off(".themeMediaEventFix"), s.onPlyrPause && s.onPlyrPause(t)
            })), s.onPlyrInit && s.onPlyrInit(t)
          }.bind(this)
        }]), theme.loadStyleOnce("https://cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.css"); else if ("IFRAME" === o.tagName && /^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(o.src)) {
          var a = window.onYouTubeIframeAPIReady, r = function () {
            var t = {playerType: "youtube", element: o}, a = e(this).data("video-id");
            t.player = new YT.Player(o, {
              videoId: a, events: {
                onStateChange: function (o) {
                  o.data === YT.PlayerState.ENDED && i && o.target.seekTo(0), o.data === YT.PlayerState.PLAYING && (e(".product-media").not(n).trigger("mediaHidden"), s.onYouTubePlay && s.onYouTubePlay(t)), o.data === YT.PlayerState.PAUSED && o.data === YT.PlayerState.ENDED && s.onYouTubePause && s.onYouTubePause(t)
                }
              }
            }), t.play = function () {
              this.player.playVideo()
            }.bind(t), t.pause = function () {
              this.player.pauseVideo()
            }.bind(t), t.destroy = function () {
              this.player.destroy()
            }.bind(t), e(this).data("player", t).addClass("product-media--video-loaded"), s.onYouTubeInit && s.onYouTubeInit(t)
          }.bind(this);
          window.YT && window.YT.Player ? r() : (window.onYouTubeIframeAPIReady = function () {
            a && a(), r()
          }, theme.loadScriptOnce("https://www.youtube.com/iframe_api"))
        }
      })), e(i).on("mediaVisible mediaVisibleInitial", ".product-media--model:not(.product-media--model-loaded):not(.product-media--model-loading)", (function (t) {
        var i = e(this).find("model-viewer")[0], o = e(this), n = "mediaVisibleInitial" != t.type;
        e(this).addClass("product-media--model-loading"), theme.loadStyleOnce("https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css"), window.Shopify.loadFeatures([{
          name: "model-viewer-ui", version: "1.0", onLoad: function () {
            e(this).data("player", new Shopify.ModelViewerUI(i)), e('<div class="theme-event-proxy">').on("mouseup", (function (t) {
              t.stopPropagation(), t.preventDefault(), e(t.currentTarget).closest(".product-media")[0].dispatchEvent(new MouseEvent("mouseup", {bubbles: !0}))
            })).appendTo(e(this).find(".shopify-model-viewer-ui__controls-overlay")), e(this).find("model-viewer").on("shopify_model_viewer_ui_toggle_play", (function () {
              e(this).closest(".product-media").on("touchstart.themeModelViewerFix mousedown.themeModelViewerFix keydown.themeModelViewerFix", (function (e) {
                e.stopPropagation()
              }))
            })).on("shopify_model_viewer_ui_toggle_pause", (function () {
              e(this).closest(".shopify-model-viewer-ui").off(".themeMediaEventFix")
            })), e(this).find("model-viewer").on("shopify_model_viewer_ui_toggle_play", (function () {
              e(".product-media").not(o).trigger("mediaHidden")
            })), e(this).addClass("product-media--model-loaded").removeClass("product-media--model-loading"), s.onModelViewerInit && s.onModelViewerInit(i), n && e(this).trigger("mediaVisible")
          }.bind(this)
        }])
      })), e(".model-json", i).length && (window.Shopify.loadFeatures([{
        name: "shopify-xr",
        version: "1.0",
        onLoad: t._setupShopifyXr.bind(e(".model-json", i))
      }]), e(document).on("shopify_xr_launch", (function () {
        e(".product-media--video-loaded").each((function () {
          e(this).data("player").pause()
        }))
      }))), setTimeout(function () {
        e(".product-media:first", this).filter(".product-media--model").trigger("mediaVisibleInitial")
      }.bind(i), 50)
    }, this.destroy = function (t) {
      e(document).off("shopify_xr_launch"), e(t).off("mediaVisible mediaVisibleInitial mediaHidden"), e(".product-media--video-loaded, .product-media--model-loaded", t).each((function () {
        e(this).data("player").destroy()
      })), e(".product-media--video video", t).off("playing pause ended"), e("model-viewer", t).off("shopify_model_viewer_ui_toggle_play shopify_model_viewer_ui_toggle_pause")
    }
  }, theme.Header = new function () {
    this.onSectionLoad = function (t) {
      this.$container = e(t), this.namespace = theme.namespaceFromSection(t), this.$nav = e(".site-nav", t), this.$navLinks = this.$nav.children(".site-nav__item:not(.site-nav__more-links)"), this.$navMoreLinksLink = e(".site-nav__more-links", this.$nav), this.$navMoreLinksContainer = e(".small-dropdown__container", this.$navMoreLinksLink), this.$navMoreLinksSubmenuContainer = e(".site-nav__more-links .more-links__dropdown-container", this.$nav), this.search = {
        ongoingRequest: null,
        ongoingTimeoutId: -1,
        throttleMs: 500,
        searchUrlKey: "searchUrl",
        resultsSelector: ".search-bar__results",
        resultsLoadingClass: "search-bar--loading-results",
        resultsLoadedClass: "search-bar--has-results",
        loadingMessage: theme.strings.searchLoading,
        moreResultsMessage: theme.strings.searchMoreResults,
        emptyMessage: theme.strings.searchNoResults
      }, e(this.$container).on("click" + this.namespace, ".js-search-form-open", this.functions.searchFormOpen.bind(this)), e(this.$container).on("click" + this.namespace, ".js-search-form-focus", this.functions.searchFormFocus.bind(this)), e(this.$container).on("click" + this.namespace, ".js-search-form-close", this.functions.searchFormClose.bind(this)), e(this.$container).on("click" + this.namespace, ".js-mobile-menu-icon", this.functions.mobileMenuOpen.bind(this)), e(this.$container).on("click" + this.namespace, ".js-close-mobile-menu", this.functions.mobileMenuClose.bind(this)), e(this.$container).on("focusin" + this.namespace, ".search-bar", this.functions.searchFocusIn.bind(this)), e(this.$container).on("focusout" + this.namespace, ".search-bar", this.functions.searchFocusOut.bind(this)), e('.search-bar[data-live-search="true"]', this.$container).length && e(this.$container).on("keyup" + this.namespace + " change" + this.namespace, '.search-bar[data-live-search="true"] input[name="q"]', this.functions.updateSearchResults.bind(this)), this.functions.setSearchTabbing.bind(this)(), e(".focus-tint").on("click" + this.namespace, this.functions.onFocusTintClick.bind(this)), e("body").toggleClass("header-has-messages", this.$container.find(".store-messages-bar").length > 0), e(".js-messages-slider", this.$container).slick({
        infinite: !0,
        autoplay: !0,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: !1,
        nextArrow: !1
      }), e(".js-mobile-messages-slider", this.$container).slick({
        infinite: !0,
        autoplay: !0,
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst: !0,
        prevArrow: !1,
        nextArrow: !1,
        responsive: [{breakpoint: 767.98, settings: "unslick"}]
      }), e(window).on("debouncedresize" + this.namespace, (function (t) {
        e(".js-mobile-messages-slider", this.$container).slick("resize")
      })), e(this.$container).on("click" + this.namespace, '.mobile-site-nav__icon, .mobile-site-nav__link[href="#"]', (function (t) {
        t.preventDefault(), e(this).siblings(".mobile-site-nav__menu").slideToggle(250), e(this).toggleClass("submenu-open")
      })), this.$container.hasClass("docking-header") && (this.desktopHeaderWasDocked = !1, this.$dockedDesktopContentsContainer = e(".docked-navigation-container__inner", t), this.$dockedDesktopBaseContainer = e(".docked-navigation-container", t), this.mobileHeaderWasDocked = !1, this.$dockedMobileContentsContainer = e(".docked-mobile-navigation-container__inner", t), this.$dockedMobileBaseContainer = e(".docked-mobile-navigation-container", t), e(this.functions.dockedNavCheck.call(this)), e(window).on("scroll" + this.namespace, this.functions.dockedNavCheck.bind(this)), e(window).on("debouncedresize" + this.namespace, this.functions.dockedNavCheck.bind(this)), e('<style id="themeDockedNavStyle">').appendTo("head"), e(this.functions.updateDockedNavHeightStyle.call(this)), e(window).on("debouncedresize" + this.namespace, this.functions.updateDockedNavHeightStyle.bind(this))), e(this.functions.menuLinkVisibilityCheck.call(this)), e(window).on("debouncedresize" + this.namespace, this.functions.menuLinkVisibilityCheck.bind(this)), e(this.$container).on("mouseenter" + this.namespace, ".more-links--with-dropdown .site-nav__item", this.functions.onMoreLinksSubMenuActive.bind(this)), this.navHoverDelay = 250, this.$navLastOpenDropdown = e(), e(this.$container).on("mouseenter" + this.namespace + " mouseleave" + this.namespace, ".site-nav__item--has-dropdown", function (t) {
        var i = e(t.currentTarget);
        if ("mouseenter" == t.type) {
          clearTimeout(this.navOpenTimeoutId), clearTimeout(i.data("navCloseTimeoutId"));
          var s = i.siblings(".open");
          s.not(this.$navLastOpenDropdown).removeClass("open"), this.$navLastOpenDropdown = i;
          var o = 0 == s.length ? 0 : this.navHoverDelay, n = setTimeout(function () {
            i.addClass("open").siblings(".open").removeClass("open");
            var e = i.children(".small-dropdown:not(.more-links-dropdown)");
            if (e.length && i.parent().hasClass("site-nav")) {
              var t = i.offset().left + e.outerWidth(), s = "", o = this.$container.outerWidth() - 10;
              t > o && (s = "translateX(" + (o - t) + "px)"), e.css("transform", s)
            }
          }.bind(this), o);
          this.navOpenTimeoutId = n, i.data("navOpenTimeoutId", n)
        } else clearTimeout(i.data("navOpenTimeoutId")), i.data("navCloseTimeoutId", setTimeout((function () {
          i.removeClass("open").children(".small-dropdown:not(.more-links-dropdown)").css("transform", "")
        }), this.navHoverDelay));
        i.children("[aria-expanded]").attr("aria-expanded", "mouseenter" == t.type)
      }.bind(this)), e(this.$container).on("keydown" + this.namespace, ".site-nav__item--has-dropdown > .site-nav__link", this.functions.dropdownLinkKeyPress.bind(this)), e(this.$container).on("touchstart" + this.namespace + " touchend" + this.namespace + " click" + this.namespace, ".site-nav__item--has-dropdown > .site-nav__link", (function (t) {
        if ("touchstart" == t.type) e(this).data("touchstartedAt", t.timeStamp); else if ("touchend" == t.type) {
          if (t.timeStamp - e(this).data("touchstartedAt") < 1e3) return e(this).data("touchOpenTriggeredAt", t.timeStamp), e(this).parent().hasClass("open") ? e(this).parent().trigger("mouseleave") : (e(".site-nav__item.open").trigger("mouseleave"), e(this).parent().trigger("mouseenter")), !1
        } else if ("click" == t.type && e(this).data("touchOpenTriggeredAt") && t.timeStamp - e(this).data("touchOpenTriggeredAt") < 1e3) return !1
      })), e(this.$container).on("touchstart" + this.namespace, ".customer-account__parent-link", (function () {
        e(this).closest(".customer-account").addClass("customer-account--using-touch")
      })), e(this.$container).on("click" + this.namespace, ".customer-account__parent-link", this.functions.onAccountIconClick.bind(this)), e(".disclosure", this.$container).each((function () {
        e(this).data("disclosure", new theme.Disclosure(e(this)))
      }))
    }, this.functions = {
      onAccountIconClick: function (t) {
        if (e(window).width() >= 768) {
          t.preventDefault();
          var i = e(t.target).closest(".customer-account").toggleClass("customer-account--reveal-menu").hasClass("customer-account--reveal-menu");
          e(t.target).closest(".customer-account__parent-link").attr("aria-expanded", i)
        }
      }, dropdownLinkKeyPress: function (t) {
        if (13 == t.which) {
          if (e(t.target).closest(".site-nav__dropdown").length && e(t.target).closest(".more-links").length) e(t.target).trigger("mouseenter"); else {
            var i = e(t.target).closest(".site-nav__item--has-dropdown").toggleClass("open").hasClass("open");
            e(t.target).attr("aria-expanded", i)
          }
          return !1
        }
      }, setSearchTabbing: function (t) {
        e(".search-bar", this.$container).each((function () {
          "none" == e(this).css("pointer-events") ? e(this).find("a, input, button").attr("tabindex", "-1") : e(this).find("a, input, button").removeAttr("tabindex")
        }))
      }, onMoreLinksSubMenuActive: function (t) {
        this.$navMoreLinksSubmenuContainer.empty();
        var i = e(t.currentTarget).children(".site-nav__dropdown");
        if (i.length) {
          var s = i.clone();
          s.find(".mega-dropdown__container .one-third").removeClass("one-third").addClass("one-half"), s.find(".mega-dropdown__container .one-quarter").removeClass("one-quarter").addClass("one-third"), s.find(".site-nav__promo-container > .three-quarters").removeClass("three-quarters").addClass("two-thirds"), s.find(".site-nav__promo-container > .one-quarter").removeClass("one-quarter").addClass("one-third"), s.appendTo(this.$navMoreLinksSubmenuContainer)
        }
        var o = this.$navMoreLinksSubmenuContainer.outerHeight() + 30;
        this.$navMoreLinksSubmenuContainer.parent().css("min-height", o), e(t.currentTarget).removeClass("more-links__parent--inactive").addClass("more-links__parent--active").siblings().removeClass("more-links__parent--active").addClass("more-links__parent--inactive"), e(t.target).attr("aria-expanded", !0), e(t.target).parent().siblings().find("a").attr("aria-expanded", !1)
      }, menuLinkVisibilityCheck: function (t) {
        var i = this.$nav.width(), s = this.$navMoreLinksLink.width(), o = 0;
        if (this.$navLinks.each((function () {
          o += e(this).width() + 4
        })), o > i) {
          o = s;
          var n = this.$navMoreLinksContainer.empty();
          this.$navLinks.each((function () {
            (o += e(this).width() + 4) > i ? (n.append(e(this).clone().removeClass("site-nav__invisible")), e(this).addClass("site-nav__invisible").find("a").attr("tabindex", "-1")) : e(this).removeClass("site-nav__invisible").find("a").removeAttr("tabindex")
          })), this.$navMoreLinksLink.attr("role", "menu"), this.$navMoreLinksContainer.find("a").removeAttr("tabindex"), this.$navMoreLinksLink.removeClass("site-nav__invisible"), this.$navMoreLinksLink.toggleClass("more-links--with-dropdown", this.$navMoreLinksLink.find(".small-dropdown:first, .mega-dropdown:first").length > 0), this.$navMoreLinksLink.toggleClass("more-links--with-mega-dropdown", this.$navMoreLinksLink.find(".mega-dropdown:first").length > 0), this.$navMoreLinksContainer.find(".small-dropdown").css("transform", "")
        } else this.$navLinks.removeClass("site-nav__invisible"), this.$navMoreLinksLink.addClass("site-nav__invisible"), this.$navMoreLinksLink.removeAttr("role"), this.$navMoreLinksContainer.empty()
      }, searchFormOpen: function (t) {
        t.preventDefault(), t.stopPropagation(), e("body").addClass("search-bar-open"), e('.search-bar:not(.mobile-menu-search):visible input[name="q"]', this.$container).focus(), this.functions.setSearchTabbing.bind(this)()
      }, searchFormFocus: function (t) {
        e('.search-bar:visible input[name="q"]', this.$container).focus()
      }, searchFormClose: function (t) {
        e("body").removeClass("search-bar-open search-bar-in-focus"), this.functions.setSearchTabbing.bind(this)(), t && t.target && e(t.target).closest(".search-bar").prev("a").focus().blur()
      }, searchFocusIn: function (t) {
        clearTimeout(this.searchFocusOutTimeout), e("body").addClass("search-bar-in-focus")
      }, searchFocusOut: function (t) {
        this.searchFocusOutTimeout = setTimeout((function () {
          e("body").removeClass("search-bar-in-focus"), e(".search-bar").removeClass("search-bar--has-results")
        }), 100)
      }, onFocusTintClick: function (e) {
        return this.functions.searchFormClose.bind(this)(), !1
      }, mobileMenuOpen: function (t) {
        e(".header-navigation", this.$container).addClass("header-navigation--open"), e(document.body, this.$container).addClass("mobile-menu-open")
      }, mobileMenuClose: function (t) {
        e(".header-navigation", this.$container).removeClass("header-navigation--open"), e(document.body, this.$container).removeClass("mobile-menu-open")
      }, updateSearchResults: function (t) {
        var i = e(t.target).closest("form"), s = i.closest(".search-bar"),
          o = i.attr("action") + (i.attr("action").indexOf("?") >= 0 ? "&" : "?") + i.serialize();
        o != i.data(this.search.searchUrlKey) && (i.data(this.search.searchUrlKey, o), this.functions._abortSearch.bind(this)(), i.find('input[name="q"]').val().length < 3 ? this.functions._searchResultsHide.bind(this)(s) : (s.addClass(this.search.resultsLoadingClass), s.find(this.search.resultsSelector).html('<div class="search-result search-result--loading">' + this.search.loadingMessage + "</div>"), this.search.ongoingTimeoutId = setTimeout(this.functions._fetchResults.bind(this, i, o, s), this.search.throttleMs)))
      }, _abortSearch: function () {
        this.search.ongoingRequest && this.search.ongoingRequest.abort(), clearTimeout(this.search.ongoingTimeoutId)
      }, _fetchResults: function (t, i, s) {
        var o, n;
        theme.shopifyFeatures.predictiveSearch ? (o = theme.routes.search_url + "/suggest.json", n = {
          q: t.find('input[name="q"]').val(),
          resources: {
            type: t.find('input[name="type"]').val(),
            limit: 6,
            options: {
              unavailable_products: "last",
              fields: s.data("live-search-meta") ? "title,product_type,variants.title,vendor,tag,variants.sku" : "title,product_type,variants.title,vendor"
            }
          }
        }) : (o = t.attr("action") + "?" + t.serialize() + "&view=data", n = null), this.search.ongoingRequest = e.ajax({
          url: o,
          data: n,
          dataType: "json",
          success: this.functions._searchResultsSuccess.bind(this, s, i)
        }).fail(function (e, t) {
          console.log("Error fetching results"), console.log(t), this.functions._searchResultsHide.bind(this, e)
        }.bind(this, s)).always(function () {
          this.search.ongoingRequest = null
        }.bind(this))
      }, _searchResultsSuccess: function (t, i, s) {
        t.addClass(this.search.resultsLoadedClass).removeClass(this.search.resultsLoadingClass);
        var o = e("<div>"), n = t.data("live-search-price"), a = t.data("live-search-vendor");
        if (t.data("live-search-meta"), s.resources.results.products && s.resources.results.products.length > 0 || s.resources.results.pages && s.resources.results.pages.length > 0 || s.resources.results.articles && s.resources.results.articles.length > 0) {
          if (s.resources.results.products) for (var r = 0; r < s.resources.results.products.length; r++) {
            console.log(s.resources.results.products[r])

            if (s.resources.results.products[r].id !== 8524623479051 && s.resources.results.products[r].id !== 8100805116171) {
              console.log('found')
            var c = s.resources.results.products[r], l = e('<a class="search-result">').attr("href", c.url),
              d = e('<div class="search-result__title">').appendTo(l);
            if (e('<div class="search-result__product">').html(c.title).appendTo(d), a && e('<div class="search-result__vendor">').text(c.vendor).appendTo(d), n) {
              var h = e('<div class="search-result__price product-price">').appendTo(d);
              parseFloat(c.price_min) != parseFloat(c.price_max) && h.append(e('<span class="product-price__from">').html(theme.strings.priceFrom)).append(" "), parseFloat(c.compare_at_price_min) > parseFloat(c.price_min) ? h.append(e('<span class="theme-money">').addClass("product-price__reduced").html(theme.Shopify.formatMoney(c.price_min, theme.moneyFormatWithCodeForProductsPreference))).append(" ").append(e('<span class="product-price__compare theme-money">').html(theme.Shopify.formatMoney(c.compare_at_price_min, theme.moneyFormat))) : e('<span class="theme-money">').html(theme.Shopify.formatMoney(c.price_min, theme.moneyFormatWithCodeForProductsPreference)).appendTo(h)
            }
            u = c.image ? e('<span class="search-result__image">').append(e('<img role="presentation" alt="">').attr("src", slate.Image.getSizedImageUrl(c.image, "100x100_crop_center"))) : e('<span class="search-result__image">').append(e('<span class="search-result__char">').html(c.title[0])), l.prepend(u).appendTo(o)
            }


          }
          if (s.resources.results.articles) for (r = 0; r < s.resources.results.articles.length; r++) {
            c = s.resources.results.articles[r], l = e('<a class="search-result">').attr("href", c.url).append(e('<span class="search-result__title">').text(c.title));
            u = c.image ? e('<span class="search-result__image">').append(e('<img role="presentation" alt="">').attr("src", slate.Image.getSizedImageUrl(c.image, "100x100_crop_center"))) : e('<span class="search-result__image">').append(e('<span class="search-result__char">').html(c.title[0])), l.prepend(u).appendTo(o)
          }
          if (s.resources.results.pages) for (r = 0; r < s.resources.results.pages.length; r++) {
            c = s.resources.results.pages[r], l = e('<a class="search-result">').attr("href", c.url).append(e('<span class="search-result__title">').text(c.title));
            var u = e('<span class="search-result__image">').append(e('<span class="search-result__char">').html(c.title[0]));
            l.prepend(u).appendTo(o)
          }
          e('<a class="search-result search-result--more">').attr("href", i).html(this.search.moreResultsMessage).appendTo(o)
        } else o.append('<div class="search-result search-result--empty">' + this.search.emptyMessage + "</div>");
        t.find(this.search.resultsSelector).html(o)
      }, _searchResultsHide: function (e) {
        e.removeClass(this.search.resultsLoadedClass).removeClass(this.search.resultsLoadingClass).find(this.search.resultsSelector).empty()
      }, dockedNavCheck: function (t) {
        var i = e(window).scrollTop(),
          s = e(window).width() >= theme.dockedNavDesktopMinWidth && this.$dockedDesktopBaseContainer.offset().top < i,
          o = e(window).width() < theme.dockedNavDesktopMinWidth && this.$dockedMobileBaseContainer.offset().top < i;
        s ? this.$dockedDesktopBaseContainer.css("height", this.$dockedDesktopContentsContainer.outerHeight()) : this.desktopHeaderWasDocked && this.$dockedDesktopBaseContainer.css("height", ""), o ? this.$dockedMobileBaseContainer.css("height", this.$dockedMobileContentsContainer.outerHeight()) : this.mobileHeaderWasDocked && this.$dockedMobileBaseContainer.css("height", ""), this.$container.toggleClass("docked-header--dock", s || o), s != this.desktopHeaderWasDocked && this.functions.menuLinkVisibilityCheck.bind(this)(), this.desktopHeaderWasDocked = s, this.mobileHeaderWasDocked = o
      }, updateDockedNavHeightStyle: function () {
        var t = theme.dockedNavHeight() + 30;
        e("#themeDockedNavStyle").html("@media (min-width:768px){.sticky-element{top:" + theme.dockedNavHeight() + "px;} .product-detail .sticky-element{top:" + t + "px;}}")
      }
    }, this.onSectionUnload = function () {
      this.$container.off(this.namespace), e(".focus-tint").off(this.namespace), e(window).off(this.namespace), e(".js-messages-slider", this.$container).slick("unslick"), e(".js-mobile-messages-slider", this.$container).slick("unslick"), e("#themeDockedNavStyle").remove(), e(".disclosure", this.$container).each((function () {
        e(this).data("disclosure").unload()
      }))
    }
  }, theme.Footer = new function () {
    this.onSectionLoad = function (t) {
      this.$container = e(t), this.namespace = theme.namespaceFromSection(t), this.$stickyFooter = e(".sticky-footer", t), e("body").removeClass("sticky-footer-not-visible sticky-footer-partly-visible sticky-footer-fully-visible sticky-footer-taller-than-page sticky-footer-scrolled-into"), this.$stickyFooter.length ? (this.functions.stickyResize.bind(this)(), this.functions.stickyScroll.bind(this)(), e(window).on("debouncedresize" + this.namespace, this.functions.stickyResize.bind(this)), e(window).on("scroll" + this.namespace, this.functions.stickyScroll.bind(this))) : (this.$footerInner = this.$container.find(".page-footer__inner "), this.functions.pushDown.call(this), e(window).on("debouncedresize" + this.namespace, this.functions.pushDown.bind(this))), e(".disclosure", this.$container).each((function () {
        e(this).data("disclosure", new theme.Disclosure(e(this)))
      }))
    }, this.functions = {
      pushDown: function () {
        var t = e(window).height() - (this.$container.offset().top + this.$footerInner.outerHeight());
        t > 0 ? this.$container.css("padding-top", t) : this.$container.css("padding-top", "")
      }, stickyScroll: function () {
        e("body").toggleClass("sticky-footer-scrolled-into", e(window).scrollTop() > this.$container.offset().top)
      }, stickyResize: function () {
        var t = this.$stickyFooter.outerHeight(), i = this.$container.offset().top, s = i < e(window).height(),
          o = i + t < e(window).height(), n = t > e(window).height();
        e("body").toggleClass("sticky-footer-not-visible", !s), e("body").toggleClass("sticky-footer-partly-visible", s && !o), e("body").toggleClass("sticky-footer-fully-visible", o), e("body").toggleClass("sticky-footer-taller-than-page", n), this.$container.css("min-height", t)
      }
    }, this.onSectionUnload = function () {
      e(window).off(this.namespace), e(".disclosure", this.$container).each((function () {
        e(this).data("disclosure").unload()
      }))
    }
  }, theme.Product = new function () {
    var t = e.extend({}, theme.variants.selectors, {
      productJson: "[data-product-json]",
      productMediaContainer: ".product-detail__images",
      productMedia: "[data-product-media]",
      productImages: "[data-product-image]",
      productMediaThumbnails: "[data-product-media-thumbnail]",
      singleOptionSelector: "[data-single-option-selector]",
      skuWrapper: ".sku-wrapper",
      sku: ".sku-wrapper__sku",
      storeAvailability: "[data-store-availability-container]"
    });
    this.onSectionLoad = function (i) {
      if (this.$container = e(i), this.namespace = theme.namespaceFromSection(i), e(t.storeAvailability, i).length && (this.storeAvailability = new theme.StoreAvailability(e(t.storeAvailability, i)[0])), e(t.productJson, this.$container).html()) {
        this.$container.attr("data-section-id"), this.productSingleObject = JSON.parse(e(t.productJson, this.$container).html());
        var s = {
          $container: this.$container,
          enableHistoryState: this.$container.data("enable-history-state") || !1,
          singleOptionSelector: t.singleOptionSelector,
          originalSelectorId: t.originalSelectorId,
          secondaryIdSelectors: t.secondaryIdSelectors,
          product: this.productSingleObject
        };
        this.settings = {}, this.settings.imageSize = "master", this.variants = new slate.Variants(s), this.$productMediaContainer = e(t.productMediaContainer, this.$container), this.$productMedia = e(t.productMedia, this.$container), this.$productImages = e(t.productImages, this.$container), this.$productMediaThumbnails = e(t.productMediaThumbnails, this.$container), this.$container.on("variantChange" + this.namespace, theme.variants.updateAddToCartState.bind(this)), this.$container.on("variantPriceChange" + this.namespace, theme.variants.updateProductPrices.bind(this)), this.$container.find(t.skuWrapper) && this.$container.on("variantChange" + this.namespace, this.functions.updateSKU.bind(this)), this.$productMediaThumbnails.length ? (this.$productMedia.length > 1 && (this.$container.on("click" + this.namespace, t.productMediaThumbnails, this.functions.updatePrimaryProductMediaFromThumbnailClick.bind(this)), this.$container.on("variantImageChange" + this.namespace, this.functions.updateProductMediaSlideshowFromVariantChange.bind(this))), this.$container.on("click" + this.namespace, t.productImages, this.functions.openGallery.bind(this))) : (this.$productMedia.length > 1 && (this.$container.on("variantImageChange" + this.namespace, this.functions.updateProductMediaColumn.bind(this)), e(document).on("click" + this.namespace + " keydown" + this.namespace, function () {
          this.$productMedia.not(".variant-dim--fixed").removeClass("variant-dim")
        }.bind(this)), e(window).on("scroll" + this.namespace + " ontouchstart" + this.namespace, function () {
          this.$productMedia.not(".variant-dim--fixed").removeClass("variant-dim")
        }.bind(this)), e(window).on("scroll" + this.namespace, this.functions.notifyMediaOfVisibilityInColumn.bind(this)), this.functions.notifyMediaOfVisibilityInColumn.bind(this)()), this.$container.on("click" + this.namespace, t.productImages, this.functions.openGallery.bind(this))), this.mediaSlideshowActive = !1, e(window).on("debouncedresize" + this.namespace, this.functions.assessMediaSlideshow.bind(this)), this.functions.assessMediaSlideshow.bind(this)(), theme.ProductMedia.init(this.$container, {
          onPlyrInit: function (t) {
            var i = e(t.element).closest(".slick-initialized");
            i.length && theme.productGallerySlideshowTabFix(i.slick("getSlick").$slides, i.slick("getSlick").currentSlide)
          }, onYoutubeInit: function (t) {
            var i = e(t.element).closest(".slick-initialized");
            i.length && theme.productGallerySlideshowTabFix(i.slick("getSlick").$slides, i.slick("getSlick").currentSlide)
          }, onModelViewerInit: function (t) {
            var i = e(t.element).closest(".slick-initialized");
            i.length && theme.productGallerySlideshowTabFix(i.slick("getSlick").$slides, i.slick("getSlick").currentSlide)
          }
        }), this.$container.find(".product-media").trigger("mediaVisibleInitial"), theme.initVariantSelectors(e(t.singleOptionSelector, i), s.product), this.variants.product.variants.length > 1 && e(window).trigger("cc-variant-updated", {
          variant: this.variants.currentVariant,
          product: this.productSingleObject
        }), this.$container.on("click", ".js-size-chart-open", (function (t) {
          t.preventDefault(), e("body").addClass("size-chart-is-open")
        })), this.$container.on("click", ".js-size-chart-close", (function () {
          e("body").removeClass("size-chart-is-open")
        })), theme.initAjaxAddToCartForm(e("form.ajax-product-form", this.$container)), theme.assessRTEImagesOnLoad(this.$container)
      }
    }, this.functions = {
      updateSKU: function (i) {
        var s = i.variant;
        s && s.sku ? (e(t.skuWrapper, this.$container).removeClass("sku-wrapper--empty"), e(t.sku, this.$container).html(s.sku)) : (e(t.skuWrapper, this.$container).addClass("sku-wrapper--empty"), e(t.sku, this.$container).empty())
      }, notifyMediaOfVisibilityInColumn: function () {
        var t = e(window).scrollTop(), i = t + e(window).height();
        e(".product-media", this.$container).each((function () {
          var s = e(this).offset().top, o = s + e(this).outerHeight();
          s > t && s < i || o > t && o < i ? !e(this).hasClass("product-media--on-screen") && (e(this).addClass("product-media--on-screen"), e(this).is(".product-media--model:not(.product-media--model-loaded)") && e(this).trigger("mediaVisibleInitial")) : e(this).hasClass("product-media--on-screen") && e(this).removeClass("product-media--on-screen").trigger("mediaHidden")
        }))
      }, _updatePrimaryProductMediaFromThumbnail: function (e) {
        if (this.$productMediaContainer.hasClass("slick-slider")) {
          var t = this.$productMedia.filter('[data-media-id="' + e.data("media-id") + '"]').closest(".slick-slide").data("slick-index");
          this.$productMediaContainer.slick("slickGoTo", t)
        }
      }, updatePrimaryProductMediaFromThumbnailClick: function (t) {
        t.preventDefault(), this.functions._updatePrimaryProductMediaFromThumbnail.bind(this)(e(t.currentTarget))
      }, updateProductMediaSlideshowFromVariantChange: function (t) {
        var i = t.variant, s = this.$productMedia.filter((function () {
          return e(this).data("media-id") == i.featured_media.id
        }));
        1 == s.length && this.functions._updatePrimaryProductMediaFromThumbnail.bind(this)(s)
      }, updateProductMediaColumn: function (t) {
        var i = t.variant, s = this.$productMedia.filter((function () {
          return e(this).data("media-id") == i.featured_media.id
        }));
        1 == s.length && (this.$productMediaContainer.hasClass("slick-slider") ? this.functions._updatePrimaryProductMediaFromThumbnail.bind(this)(s) : (clearTimeout(this.variantScrollTimeoutId), this.variantScrollTimeoutId = setTimeout(function () {
          var t = s.offset().top - theme.dockedNavHeight(), i = s.closest(".product-detail"),
            o = i.offset().top + i.height() - i.find(".product-detail__detail").outerHeight() - 20;
          e("html,body").animate({scrollTop: Math.min(t, o)}, 500, function () {
            s.removeClass("variant-dim"), this.$productImages.not(s).addClass("variant-dim variant-dim--fixed"), setTimeout((function () {
              e(".variant-dim--fixed").removeClass("variant-dim--fixed")
            }), 500)
          }.bind(this))
        }.bind(this), 25)))
      }, assessMediaSlideshow: function (t) {
        var i = e(window).width(), s = !1;
        if (this.$productMediaContainer.children().length > 1 && (s = !1), i < 768 || e(".product-detail__thumbnails").length) {
          if (!this.mediaSlideshowActive) {
            var o, n = this.$productMediaContainer.data("featured-media-id");
            this.$productMediaContainer.data("featured-media-id", null), o = this.$productMediaContainer.find('[data-media-id="' + n + '"]').parent().index();
            var a = this.$productMediaContainer.slick({
              infinite: !1,
              fade: !0,
              arrows: !1,
              dots: !1,
              adaptiveHeight: !0,
              prevArrow: theme.icons.slideshowPrevArrow,
              nextArrow: theme.icons.slideshowNextArrow,
              appendArrows: e(".slick-external-controls .slick-arrows", this.$container),
              initialSlide: o,
              waitForAnimate: !1,
              responsive: [{breakpoint: 767.98, settings: {fade: !1, arrows: !0, dots: s}}]
            });
            a.find(".product-media").trigger("mediaVisibleInitial"), a.on("afterChange", (function (t, i, s) {
              var o = e(".product-media", i.$slides[s]);
              e(".product-media").not(o).trigger("mediaHidden"), o.trigger("mediaVisible");
              var n = e("[data-product-image]", i.$slides[s]);
              e('.product-detail__thumbnail[data-media-id="' + n.data("media-id") + '"]').addClass("thumb-active").siblings().removeClass("thumb-active"), theme.productGallerySlideshowTabFix(i.$slides, s), e(this).closest(".quickbuy-container").trigger("changedsize")
            })), theme.productGallerySlideshowTabFix(a.slick("getSlick").$slides, a.slick("getSlick").currentSlide), this.mediaSlideshowActive = !0
          }
        } else this.mediaSlideshowActive && (this.$productMediaContainer.slick("unslick"), this.mediaSlideshowActive = !1)
      }, openGallery: function (t) {
        t.preventDefault();
        var i = document.querySelectorAll(".pswp")[0], s = [];
        this.$productImages.each((function (t) {
          e(this).data("image-index", t);
          var i = {src: e(this).attr("href"), w: e(this).data("image-w"), h: e(this).data("image-h")},
            o = e(this).find("img")[0];
          void 0 !== o.currentSrc && (i.msrc = o.currentSrc), s.push(i)
        }));
        var o = {history: !1, captionEl: !1, shareEl: !1, fullscreenEl: !1};
        o.index = e(t.target).closest("a").data("image-index"), o.getThumbBoundsFn = function (e) {
          var t = this.$productImages[e].getElementsByTagName("img")[0],
            i = window.pageYOffset || document.documentElement.scrollTop, s = t.getBoundingClientRect();
          return {x: s.left, y: s.top + i, w: s.width}
        }.bind(this), this.imageGallery = new PhotoSwipe(i, PhotoSwipeUI_Default, s, o), this.imageGallery.init(), this.imageGallery.listen("destroy", function () {
          this.imageGallery = null
        }.bind(this));
        var n = this;
        this.imageGallery.listen("afterChange", (function () {
          var t = this.currItem.src, i = n.$productImages.filter((function () {
            return e(this).attr("href") == t
          }));
          n.functions._updatePrimaryProductMediaFromThumbnail.bind(n)(i)
        }))
      }
    }, this.onSectionUnload = function () {
      this.$container.off(this.namespace), e(document).off(this.namespace), e(window).off(this.namespace), this.imageGallery && this.imageGallery.close(), this.storeAvailability && this.storeAvailability.onSectionUnload(), theme.ProductMedia.destroy(this.$container), this.$container.find(".slick-initialized").slick("unslick").off("afterChange"), theme.unloadAjaxAddToCartForm(e("form.ajax-product-form", this.$container))
    }
  }, theme.Blog = new function () {
    var t = ".featured-blog__header, .blog-featured-image", i = ".featured-blog__header-image, .blog-image";
    this.onSectionLoad = function (s) {
      this.$container = e(s), this.namespace = theme.namespaceFromSection(s), this.$header = e(t, this.$container), this.$headerImage = e(i, this.$container), e(".js-content-products-slider .grid", this.$container).each(function (t, i) {
        theme.peekCarousel.init(this.$container, e(i), this.namespace, (function () {
          return !0
        }), !1, {
          infinite: !1,
          slidesToShow: 3,
          slidesToScroll: 1,
          swipeToSlide: !0,
          dots: !1,
          prevArrow: e(i).closest(".content-products").find(".content-products-controls .prev"),
          nextArrow: e(i).closest(".content-products").find(".content-products-controls .next"),
          responsive: [{
            breakpoint: e(".single-column-layout", this.$container).length ? 768 : 960,
            settings: {slidesToShow: 1}
          }]
        })
      }.bind(this)), this.functions.assessSection.bind(this)(), e(window).on("debouncedresize" + this.namespace, this.functions.assessSection.bind(this))
    }, this.functions = {
      assessSection: function (t) {
        if (768 > e(window).width()) this.$headerImage.css("height", ""); else {
          var i = parseInt(this.$header.css("padding-top"));
          this.$headerImage.css("height", e(window).height() - 2 * i - theme.dockedNavHeight())
        }
      }
    }, this.onSectionUnload = function (t) {
      this.$container.off(this.namespace), e(window).off(this.namespace), theme.peekCarousel.destroy(this.$container, e(".js-content-products-slider .grid", this.$container), this.namespace)
    }
  }, theme.Article = new function () {
    var t = ".js-content-products-slider .grid";
    this.onSectionLoad = function (i) {
      this.$container = e(i), this.namespace = theme.namespaceFromSection(i), e(".template-article .rte").width(), e(t, this.$container).each(function (t, i) {
        theme.peekCarousel.init(this.$container, e(i), this.namespace, (function () {
          return !0
        }), !1, {
          infinite: !1,
          slidesToShow: 3,
          slidesToScroll: 1,
          swipeToSlide: !0,
          dots: !1,
          prevArrow: e(i).closest(".content-products").find(".content-products-controls .prev"),
          nextArrow: e(i).closest(".content-products").find(".content-products-controls .next"),
          responsive: [{
            breakpoint: e(".single-column-layout", this.$container).length ? 768 : 960,
            settings: {slidesToShow: 1}
          }]
        })
      }.bind(this)), theme.assessRTEImagesOnLoad(this.$container)
    }, this.onSectionUnload = function () {
      this.$container.off(this.namespace), e(window).off(this.namespace), theme.peekCarousel.destroy(this.$container, e(t, this.$container), this.namespace)
    }
  }, theme.Slideshow = new function () {
    this.onSectionLoad = function (t) {
      this.$container = e(t), this.namespace = theme.namespaceFromSection(t), this.$slideshow = e(".js-slideshow-section", this.$container), this.$slideshow.children().length, this.$slideshow.slick({
        infinite: !0,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: !0,
        adaptiveHeight: !1,
        autoplay: this.$slideshow.data("autoplay"),
        autoplaySpeed: this.$slideshow.data("autoplayspeed"),
        prevArrow: e(".full-width-slideshow-controls .prev", this.$container),
        nextArrow: e(".full-width-slideshow-controls .next", this.$container)
      }), e(window).on("debouncedresize" + this.namespace, this.functions.onResize.bind(this)), theme.checkOverlaps && theme.checkOverlaps()
    }, this.functions = {
      onResize: function (e) {
        this.$slideshow.slick("setPosition")
      }
    }, this.onBlockSelect = function (t) {
      this.$slideshow.slick("slickGoTo", e(t).data("slick-index"), !0).slick("slickPause")
    }, this.onBlockDeselect = function (e) {
      this.$slideshow.slick("slickPlay")
    }, this.onSectionUnload = function () {
      this.$container.off(this.namespace), e(window).off(this.namespace), this.$slideshow.slick("unslick")
    }
  }, theme.Banner = new function () {
    this.onSectionLoad = theme.Slideshow.onSectionLoad, this.onSectionUnload = theme.Slideshow.onSectionUnload, this.onBlockSelect = theme.Slideshow.onBlockSelect, this.onBlockDeselect = theme.Slideshow.onBlockDeselect, this.functions = theme.Slideshow.functions
  }, theme.StandoutCollection = new function () {
    this.onSectionLoad = function (t) {
      this.$container = e(t), this.namespace = theme.namespaceFromSection(t), theme.peekCarousel.init(this.$container, e(".js-standout-collection-slider", this.$container), this.namespace, (function () {
        return !0
      }), !1, {
        infinite: !1,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: !1,
        prevArrow: e(".standout-collection-slider__controls .prev", this.$container),
        nextArrow: e(".standout-collection-slider__controls .next", this.$container)
      })
    }, this.onSectionUnload = function () {
      this.$container.off(this.namespace), theme.peekCarousel.destroy(this.$container, e(".js-standout-collection-slider", this.$container), this.namespace)
    }
  }, theme.GetTheLook = new function () {
    var t = ".get-the-look__image-container",
      i = ".get-the-look__image-container .placeholder-svg, .get-the-look__image-container .rimage-background",
      s = ".js-get-the-look-slider", o = ".get-the-look__product:first";
    this.onSectionLoad = function (n) {
      this.$container = e(n), this.namespace = theme.namespaceFromSection(n), this.$header = e(t, this.$container), this.$headerImage = e(i, this.$container), this.$slideshow = e(s, this.$container), this.$firstProduct = e(o, this.$container), theme.peekCarousel.init(this.$container, this.$slideshow, this.namespace, function () {
        return this.$firstProduct.length && 0 == parseInt(this.$firstProduct.css("margin-right"))
      }.bind(this)), this.functions.assessSection.bind(this)(), e(window).on("debouncedresize" + this.namespace, this.functions.assessSection.bind(this))
    }, this.functions = {
      assessSection: function (t) {
        if (this.$firstProduct.length && 0 == parseInt(this.$firstProduct.css("margin-right"))) this.$headerImage.css("height", ""); else {
          var i = parseInt(this.$header.css("margin-top"));
          this.$headerImage.css("height", e(window).height() - 2 * i - theme.dockedNavHeight())
        }
      }
    }, this.onSectionUnload = function () {
      this.$container.off(this.namespace), e(window).off(this.namespace), theme.peekCarousel.destroy(this.$container, this.$slideshow, this.namespace)
    }
  }, theme.PromotionalImages = new function () {
    this.onSectionLoad = function (t) {
      this.$container = e(t), this.namespace = theme.namespaceFromSection(t), e(this.functions.assessSection.call(this)), e(window).on("debouncedresize" + this.namespace, this.functions.assessSection.bind(this))
    }, this.functions = {
      assessSection: function (t) {
        e(window).width() >= 768 ? e(".promotional-row").each((function () {
          var t = 0;
          e(this).find(".text_over_image .promotional-row__content").each((function () {
            var i = e(this).outerHeight() + 60;
            i > t && (t = i)
          })), e(this).find(".text_over_image").css("min-height", t)
        })) : e(".promotional-row .text_over_image").css("min-height", "")
      }
    }, this.onSectionUnload = function () {
      this.$container.off(this.namespace), e(window).off(this.namespace)
    }
  }, theme.FeaturedCollection = new function () {
    var t = "[data-carousel-enabled]";
    this.onSectionLoad = function (i) {
      this.$container = e(i), this.namespace = theme.namespaceFromSection(i), this.$slideshow = e(t, this.$container), this.$slideshow.each(function (t, i) {
        theme.peekCarousel.init(this.$container, e(i), this.namespace, (function () {
          return !0
        }), !1, {
          infinite: !1,
          slidesToShow: this.$slideshow.data("slides-per-row"),
          slidesToScroll: 1,
          swipeToSlide: !0,
          dots: !1,
          prevArrow: e(".featured-collection-controls .prev", this.$container),
          nextArrow: e(".featured-collection-controls .next", this.$container),
          responsive: [{breakpoint: 768, settings: {slidesToShow: 1, nextArrow: !1, prevArrow: !1}}]
        })
      }.bind(this))
    }, this.onSectionUnload = function () {
      this.$container.off(this.namespace), theme.peekCarousel.destroy(this.$container, this.$slideshow, this.namespace)
    }
  }, theme.ListCollections = new function () {
    this.onSectionLoad = function (t) {
      this.$container = e(t), this.namespace = theme.namespaceFromSection(t), theme.assessRTEImagesOnLoad(this.$container), e(".js-list-collection-slider", this.$container).each(function (t, i) {
        theme.peekCarousel.init(this.$container, e(i), this.namespace, (function () {
          return !0
        }), !1, {
          infinite: !0,
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: !1,
          prevArrow: e(i).siblings(".standout-collection-slider__controls").children(".prev"),
          nextArrow: e(i).siblings(".standout-collection-slider__controls").children(".next"),
          responsive: [{breakpoint: 768, settings: {slidesToShow: 1}}]
        })
      }.bind(this))
    }, this.onSectionUnload = function () {
      this.$container.off(this.namespace), theme.peekCarousel.destroy(this.$container, e(".js-list-collection-slider", this.$container), this.namespace)
    }
  }, theme.Cart = new function () {
    this.onSectionLoad = function (t) {
      if (this.$container = e(t), this.namespace = theme.namespaceFromSection(t), this.$container.on("click" + this.namespace, ".js-shipping-calculator-trigger", (function () {
        var t = e(this), i = t.parents(".shipping-calculator-container");
        i.toggleClass("calculator-open"), i.hasClass("calculator-open") ? (t.html(theme.strings.cart_shipping_calculator_hide_calculator), i.children(".shipping-calculator").slideDown(250)) : (t.html(theme.strings.cart_shipping_calculator_title), i.children(".shipping-calculator").slideUp(250))
      })), this.$container.on("click" + this.namespace, ".js-cart-notes-trigger", (function () {
        var t = e(this), i = t.parent(".cart-notes-container");
        i.toggleClass("notes-open"), i.hasClass("notes-open") ? (t.html(theme.strings.cart_general_hide_note), i.children(".cart-notes").slideDown(250)) : (t.html(theme.strings.cart_general_show_note), i.children(".cart-notes").slideUp(250))
      })), theme.cartNoteMonitor.load(e('.cart-notes [name="note"]', this.$container)), this.$container.data("ajax-update")) {
        var i = this.functions.updateCart.bind(this);
        this.$container.on("keyup" + this.namespace + " change" + this.namespace, ".quantity__change input", (function () {
          if ((!e(this).data("initial-value") || e(this).data("initial-value") != e(this).val()) && 0 != e(this).val().length && "0" != e(this).val()) {
            var t = e(this).attr("id");
            i({line: e(this).data("line"), quantity: e(this).val()}, (function () {
              e("#" + t).focus()
            })), e(this).data("previousValue", e(this).val())
          }
        })), this.$container.on("click" + this.namespace, ".quantity__minus, .quantity__plus", (function (t) {
          var i = e(this).closest(".quantity__change").find(".quantity__number");
          return e(this).hasClass("quantity__minus") ? i.val(parseInt(i.val()) - 1).trigger("change") : i.val(parseInt(i.val()) + 1).trigger("change"), !1
        }))
      }
      this.$container.on("focusin" + this.namespace + " click" + this.namespace, "input.quantity__number", (function () {
        e(this).select()
      })).on("mouseup" + this.namespace, "input.quantity__number", (function (e) {
        e.preventDefault()
      })), e("#terms", t).length > 0 && e(document).on("click" + this.namespace, '[name="checkout"], a[href*="/checkout"]', (function () {
        if (0 == e("#terms:checked").length) return alert(theme.strings.cartTermsNotChecked), !1
      })), this.$recentlyViewed = e(".recently-viewed", this.$container), this.$recentlyViewed.length && (this.functions.loadRecentlyViewed.bind(this)(), theme.loadRecentlyViewed(this.$recentlyViewed))
    }, this.functions = {
      loadRecentlyViewed: function (e) {
        if (theme.storageAvailable("localStorage")) {
          var t = theme.getRecentProducts();
          if (t.length) {
            var i = this.$recentlyViewed.data("exclude"), s = [];
            i.length && (s = i.split(","));
            for (var o = this.$recentlyViewed.find(".grid"), n = 0, a = 0, r = this.$recentlyViewed.data("show-vendor"), c = this.$recentlyViewed.data("show-hover-image"); n < 6 && a < t.length;) {
              for (var l = !0, d = 0; d < s.length; d++) if (t[a].handle == s[d]) {
                l = !1;
                break
              }
              l && (n++, theme.addRecentProduct(t, a, o, c, r)), a++
            }
            n > 0 && this.$recentlyViewed.removeClass("hidden")
          }
        }
      }, updateCart: function (t, i) {
        var s = this;
        s.cartXhr && s.cartXhr.abort(), s.cartRefreshXhr && s.cartRefreshXhr.abort(), s.cartXhr = e.ajax({
          type: "POST",
          url: theme.routes.cart_change_url + ".js",
          data: t,
          dataType: "json",
          success: function (t) {
            s.cartRefreshXhr && s.cartRefreshXhr.abort(), s.cartRefreshXhr = e.ajax({
              type: "GET",
              url: theme.routes.cart_url + "?sections=main-cart",
              success: function (t) {
                var s = [".cart-items", ".subtotal-row"], o = e(t["main-cart"]);
                o.find(".fade-in").removeClass("fade-in");
                for (var n = 0; n < s.length; n++) e('[data-section-type="cart"] ' + s[n]).html(o.find(s[n]).html());
                i()
              },
              error: function (e) {
                "abort" != e.statusText && (console.log("Error refreshing page"), console.log(e))
              },
              complete: function () {
                s.cartRefreshXhr = null
              }
            })
          },
          error: function (e) {
            console.log("Error processing update"), console.log(e)
          }
        })
      }
    }, this.onSectionUnload = function () {
      this.$container.off(this.namespace), e(document).off(this.namespace), this.$recentlyViewed.length && theme.unloadRecentlyViewed(this.$recentlyViewed), theme.cartNoteMonitor.unload(e('.cart-notes [name="note"]', this.$container))
    }
  }, theme.ImageWithText = new function () {
    this.onSectionLoad = function (t) {
      function i(e) {
        var t = this.$image.height() / this.$image.width(), i = this.$imageContainer.outerWidth() * t;
        this.$imageContainer.toggleClass("image-with-text__image--inset", i < this.$text.outerHeight())
      }

      this.namespace = theme.namespaceFromSection(t), this.$container = e(t), this.$imageContainer = e(".image-with-text__image", t), this.$image = e(".image-with-text__image .rimage__image", t), this.$text = e(".image-with-text__content", t), e(window).on("debouncedresize" + this.namespace, i.bind(this)), e(i.call(this))
    }, this.onSectionUnload = function () {
      e(window).off(this.namespace)
    }
  }, theme.FeaturedProduct = new function () {
    this.onSectionLoad = function (t) {
      this.namespace = theme.namespaceFromSection(t), this.$container = e(t), this.$row = e(".featured-product-section", t), this.$imageOuterContainer = e(".featured-product-image", t), this.$mediaContainer = e(".featured-product-image-link, .product-media-wrapper", t), this.$media = e(".product-media", t), this.$media.length && theme.ProductMedia.init(this.$container), e(window).on("debouncedresize" + this.namespace, this.functions.assessInset.bind(this)), e(this.functions.assessInset.call(this))
    }, this.functions = {
      assessInset: function (e) {
        var t = this.$mediaContainer.height() / this.$mediaContainer.width(),
          i = Math.round(this.$imageOuterContainer.outerWidth() * t);
        this.$imageOuterContainer.toggleClass("featured-product-image--inset", i < this.$row.height())
      }
    }, this.onSectionUnload = function () {
      this.$media.length && theme.ProductMedia.destroy(this.$container), e(window).off(this.namespace)
    }
  }, theme.RecentlyViewed = new function () {
    var t = ".recently-viewed";
    this.onSectionLoad = function (i) {
      this.$container = e(i), this.namespace = theme.namespaceFromSection(i), this.$recentlyViewed = e(t, this.$container), this.$recentlyViewed.length && (this.functions.loadRecentlyViewed.bind(this)(), theme.loadRecentlyViewed(this.$recentlyViewed))
    }, this.functions = {
      loadRecentlyViewed: function (e) {
        if (theme.storageAvailable("localStorage")) {
          var t = {
            handle: this.$recentlyViewed.data("handle"),
            url: this.$recentlyViewed.data("url").split("?")[0],
            title: this.$recentlyViewed.data("title"),
            vendor: this.$recentlyViewed.data("vendor"),
            available: this.$recentlyViewed.data("available"),
            image: this.$recentlyViewed.data("image"),
            image2: this.$recentlyViewed.data("image2")
          }, i = theme.addToAndReturnRecentProducts(t);
          if (i.length > 1) for (var s = this.$recentlyViewed.removeClass("hidden").find(".grid"), o = this.$recentlyViewed.data("show-vendor"), n = this.$recentlyViewed.data("show-hover-image"), a = Math.max(0, i.length - 6 - 1), r = i.length - 1, c = a; c < r; c++) theme.addRecentProduct(i, c, s, n, o)
        }
      }
    }, this.onSectionUnload = function () {
      this.$recentlyViewed.length && theme.unloadRecentlyViewed(this.$recentlyViewed)
    }
  }, theme.SearchTemplate = new function () {
    var t = ".cc-filters-results";
    this.onSectionLoad = function (i) {
      this.$container = e(i), this.namespace = theme.namespaceFromSection(i), this.$productsContainer = e(t, i)
    }, this.onSectionUnload = function () {
      this.$container.off(this.namespace), e(window).off(this.namespace)
    }
  }, theme.Testimonials = new function () {
    this.onSectionLoad = function (t) {
      if (this.$container = e(t), this.namespace = theme.namespaceFromSection(t), this.$slideshow = e(".js-testimonials-section", this.$container), this.$slideshow.children().length, this.$slideshow.children().length > 1) var i = !0;
      this.$slideshow.slick({
        infinite: !0,
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: !0,
        adaptiveHeight: !1,
        autoplay: this.$slideshow.data("autoplay"),
        autoplaySpeed: this.$slideshow.data("autoplayspeed"),
        arrows: !1,
        responsive: [{breakpoint: 768, settings: {slidesToShow: 1, dots: i}}]
      }), e(window).on("debouncedresize" + this.namespace, this.functions.onResize.bind(this))
    }, this.functions = {
      onResize: function (e) {
        this.$slideshow.slick("setPosition")
      }
    }, this.onBlockSelect = function (t) {
      this.$slideshow.slick("slickGoTo", e(t).data("slick-index"), !0).slick("slickPause")
    }, this.onBlockDeselect = function (e) {
      this.$slideshow.slick("slickPlay")
    }, this.onSectionUnload = function () {
      this.$container.off(this.namespace), e(window).off(this.namespace), this.$slideshow.slick("unslick")
    }
  }, theme.Gallery = new function () {
    var t = ".gallery--mobile-carousel";
    this.onSectionLoad = function (i) {
      if (this.$container = e(i), this.namespace = theme.namespaceFromSection(i), ($slideshow = e(t, this.$container)).length) {
        var s = function () {
          var t = $slideshow.hasClass("slick-slider"), i = 768 > e(window).width();
          if (i || e(".lazyload--manual", $slideshow).removeClass("lazyload--manual").addClass("lazyload"), t && !i) {
            $slideshow.slick("unslick").off("init"), $slideshow.find("a, .gallery__item").removeAttr("tabindex").removeAttr("role");
            var s = $slideshow.data("grid"), o = null;
            $slideshow.find(".gallery__item").each((function (t) {
              t % s == 0 && (o = e('<div class="gallery__row">').appendTo($slideshow)), e(this).appendTo(o)
            }))
          } else !t && i && ($slideshow.find(".gallery__item").appendTo($slideshow), $slideshow.find(".gallery__row").remove(), $slideshow.on("init", (function () {
            e(".lazyload--manual", this).removeClass("lazyload--manual").addClass("lazyload")
          })).slick({
            autoplay: !1,
            fade: !1,
            infinite: !0,
            useTransform: !0,
            dots: !0,
            prevArrow: e(".gallery-slideshow-controls .prev", this.$container),
            nextArrow: e(".gallery-slideshow-controls .next", this.$container)
          }))
        };
        s(), e(window).on("debouncedresize.themeSection" + this.$container, s)
      }
    }, this.onSectionUnload = function () {
      this.$container.off(this.namespace), e(window).off(this.namespace), e(".slick-slider", this.$container).each((function () {
        e(this).slick("unslick").off("init")
      }))
    }, this.onBlockSelect = function (t) {
      e(t).closest(".slick-slider").each((function () {
        e(this).slick("slickGoTo", e(this).data("slick-index")).slick("slickPause")
      }))
    }, this.onBlockDeselect = function (t) {
      e(t).closest(".slick-slider").each((function () {
        e(this).slick("slickPlay")
      }))
    }
  }, theme._initCustomerAddressCountryDropdown = function () {
    new Shopify.CountryProvinceSelector("AddressCountryNew", "AddressProvinceNew", {hideElement: "AddressProvinceContainerNew"}), e("#AddressCountryNew-modal").length && new Shopify.CountryProvinceSelector("AddressCountryNew-modal", "AddressProvinceNew-modal", {hideElement: "AddressProvinceContainerNew-modal"}), e(".address-country-option").each((function () {
      var t = e(this).data("form-id");
      new Shopify.CountryProvinceSelector("AddressCountry_" + t, "AddressProvince_" + t, {hideElement: "AddressProvinceContainer_" + t})
    }))
  }, theme._setupCustomAddressModal = function () {
    var t = "-modal";
    e(".lightbox-content form, .lightbox-content input[id], .lightbox-content select[id], .lightbox-content div[id]").each((function () {
      e(this).attr("id", e(this).attr("id") + t)
    })), e(".lightbox-content label[for]").each((function () {
      e(this).attr("for", e(this).attr("for") + t)
    })), e(".lightbox-content .address-country-option").each((function () {
      var i = e(this).data("form-id") + t;
      e(this).attr("data-form-id", i).data("form-id", i)
    })), theme._initCustomerAddressCountryDropdown()
  }, theme.customerAddresses = void (!!(h = e("#AddressNewForm")).length && (Shopify && theme._initCustomerAddressCountryDropdown(), e(".address-new-toggle").on("click", (function () {
    return e.colorbox({
      transition: "fade",
      html: '<div class="lightbox-content">' + h.html() + "</div>",
      onComplete: theme._setupCustomAddressModal
    }), !1
  })), e(".address-edit-toggle").on("click", (function () {
    var t = e(this).data("form-id");
    return e.colorbox({
      transition: "fade",
      html: '<div class="lightbox-content">' + e("#EditAddress_" + t).html() + "</div>",
      onComplete: theme._setupCustomAddressModal
    }), !1
  })), e(".address-delete").on("click", (function () {
    var t = e(this), i = t.data("form-id");
    confirm(t.data("confirm-message") || "Are you sure you wish to delete this address?") && Shopify.postLink(theme.routes.account_addresses_url + "/" + i, {parameters: {_method: "delete"}})
  })), e("#AddressNewForm .errors").length && e(".address-new-toggle").click(), e(".grid .address-card .errors").length && e(".grid .address-card .errors").first().closest(".address-card").find(".address-edit-toggle").click())), theme.customerLogin = function () {
    var t = "#RecoverPassword", i = "#HideRecoverPasswordLink";

    function s(t) {
      t.preventDefault(), o(e(this).closest(".container"))
    }

    function o(t) {
      e("[id=RecoverPasswordForm]", t).toggleClass("hide"), e("[id=CustomerLoginForm]", t).toggleClass("hide")
    }

    e(document).on("click", t, s), e(document).on("click", i, s), e(t).length && ("#recover" === window.location.hash && o(null), e(".reset-password-success").length && e("#ResetSuccess").removeClass("hide"))
  }(), theme.icons = {
    close: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>',
    slideshowPrevArrow: '<button class="slick-prev" aria-label="' + theme.strings.previous + '"><svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h24v24H0z" fill="none"/><path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/></svg></button>',
    slideshowNextArrow: '<button class="slick-next" aria-label="' + theme.strings.next + '"><svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h24v24H0z" fill="none"/><path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"/></svg></button>'
  }, theme.initVariantSelectors = function (t, i, s) {
    var o = t.filter((function () {
      return "listed" == e(this).data("selector-type")
    }));
    if (o.each((function () {
      var t = e(this).find(".js-option-title");
      t.length && (t.data("default-content", t.html()), e(this).on("change", (function () {
        t.data("default-content", e(this).find(".opt-btn:checked").val())
      })).on("mouseenter", ".opt-label", (function () {
        t.html(e(this).prev().val())
      })).on("mouseleave", ".opt-label", (function () {
        t.html(t.data("default-content"))
      })))
    })), o.length > 0) for (var n = 0; n < i.options.length; n++) {
      for (var a = {}, r = 0; r < i.variants.length; r++) {
        var c = i.variants[r];
        void 0 === a[c.options[n]] && (a[c.options[n]] = !1), c.available && (a[c.options[n]] = !0)
      }
      for (var l in a) a[l] || e(t[n]).find(".opt-btn").filter((function () {
        return e(this).val() == l
      })).addClass("is-unavailable")
    }
    s && e.colorbox.resize()
  }, theme.namespaceFromSection = function (t) {
    return [".", e(t).data("section-type"), e(t).data("section-id")].join("")
  }, theme.dockedNavDesktopMinWidth = 768, theme.dockedNavHeight = function () {
    if (e(window).width() >= theme.dockedNavDesktopMinWidth) {
      if (e(".docked-navigation-container").length) return e(".docked-navigation-container__inner").height()
    } else if (e(".docked-mobile-navigation-container").length) return e(".docked-mobile-navigation-container__inner").height();
    return 0
  }, theme.resizeAccent = function () {
    var t = 0, i = e(".accent-background").next();
    if (i.length) {
      var s = parseInt(i.css("margin-top"));
      "shopify-section-banner" !== i[0].id || i.children().length || i.text().trim().length || (i = i.next()), t = i.find(".sticky-element").length ? Math.round(i.find(".sticky-element").outerHeight() / 2 + s) : Math.round(i.outerHeight() / 2 + s), e(".accent-background").css("height", t)
    } else t = "";
    e(".accent-background").css("height", t)
  }, theme.peekCarousel = {
    init: function (t, i, s, o, n, a) {
      theme.peekCarousel._checkAdvice(t);
      var r = {
        $slideshows: i,
        useCarouselCheckFn: o,
        removeClasses: n,
        slickConfig: "object" == typeof a ? a : {
          infinite: !1,
          slidesToShow: 1,
          slidesToScroll: 1,
          swipeToSlide: !0,
          dots: !1,
          arrows: !1
        }
      };
      theme.peekCarousel._assess.bind(r)(), e(window).on("debouncedresize" + s, theme.peekCarousel._assess.bind(r)), e(".product-carousel-peek__advice", t).on("click", (function () {
        e(this).closest(".product-carousel-peek").find(".slick-initialized").slick("slickNext").trigger("dismissAdvice")
      }))
    }, destroy: function (t, i, s) {
      i.hasClass("slick-initialized") && i.slick("unslick").off("swipe dismissAdvice afterChange init"), e(window).off("debouncedresize" + s, theme.peekCarousel._assess), e(".product-carousel-peek__advice", t).off("click")
    }, _assess: function () {
      for (var t = 0; t < this.$slideshows.length; t++) {
        var i = e(this.$slideshows[t]);
        this.useCarouselCheckFn() ? i.hasClass("slick-initialized") || (this.removeClasses && i.children().each((function () {
          e(this).data("peekOriginalClassName", this.className), this.className = ""
        })), 0 == i.children().length && i.closest(".product-carousel-peek").addClass("product-carousel-peek--empty"), 1 == i.children().length && i.closest(".product-carousel-peek").addClass("product-carousel-peek--single"), i.on("afterChange init", theme.peekCarousel._lazyLoadProduct), i.slick(this.slickConfig).on("swipe dismissAdvice", theme.peekCarousel._dismissAdviceOnSlickSwipe)) : i.hasClass("slick-initialized") && (i.slick("unslick").off("swipe dismissAdvice afterChange"), this.removeClasses && i.children().each((function () {
          this.className = e(this).data("peekOriginalClassName")
        })))
      }
    }, _checkAdvice: function (t) {
      "1" != e.cookie("theme.boost.dismissPeekAdvice") && e(".product-carousel-peek", t).addClass("product-carousel-peek--show-advice")
    }, _dismissAdvice: function () {
      e.cookie("theme.boost.dismissPeekAdvice", "1", {
        expires: 7,
        path: "/",
        domain: window.location.hostname
      }), e(".product-carousel-peek").addClass("product-carousel-peek--dismiss-advice")
    }, _dismissAdviceOnSlickSwipe: function (t, i) {
      theme.peekCarousel._dismissAdvice(), e(this).off("swipe")
    }, _lazyLoadProduct: function (t, i) {
      i.$slides.filter("[data-lazy-product-url]").filter((function () {
        return e(this).hasClass("slick-active") || e(this).prev().hasClass("slick-active")
      })).each((function () {
        var t = e(this);
        e.get(e(this).data("lazy-product-url") + "?sections=product-block", (function (i) {
          t.html(e(i["product-block"]).children().html())
        })), t.removeAttr("data-lazy-product-url")
      }))
    }
  }, theme.productGallerySlideshowTabFix = function (t, i) {
    e(t[i]).attr("tabindex", "-1").find("[tabindex]").each((function () {
      e(this).attr("tabindex", "0"), e(this).filter("model-viewer").attr("tabindex", "-1")
    })), e(t).not(t[i]).attr("tabindex", "-1").find("a, input, select, textarea, button, iframe, video, model-viewer, [tabindex]").each((function () {
      e(this).attr("tabindex", "-1")
    }))
  }, e((function () {
    function t() {
      e(".tabs:not(:has(.tab--active)) a:first").trigger("assess")
    }

    slate.a11y.pageLinkFocus(e(window.location.hash)), e(".in-page-link").on("click", (function (t) {
      slate.a11y.pageLinkFocus(e(t.currentTarget.hash))
    })), e(document).on("keyup.themeTabCheck", (function (t) {
      9 === t.keyCode && (e("body").addClass("tab-used"), e(document).off("keyup.themeTabCheck"))
    })), slate.rte.wrapTable({
      $tables: e(".rte table"),
      tableWrapperClass: "rte__table-wrapper"
    }), slate.rte.wrapIframe({
      $iframes: e('.rte iframe[src*="youtube.com/embed"],.rte iframe[src*="player.vimeo"]'),
      iframeWrapperClass: "rte__video-wrapper"
    }), slate.cart.cookiesEnabled() && (document.documentElement.className = document.documentElement.className.replace("supports-no-cookies", "supports-cookies")), e(document).on("change focusout inputstateEmpty", ".input-wrapper input, .input-wrapper textarea", (function () {
      e(this).closest(".input-wrapper").toggleClass("is-empty", 0 == e(this).val().length)
    })), e(document).on("focusin focusout", ".input-wrapper input, .input-wrapper textarea", (function (t) {
      e(this).closest(".input-wrapper").toggleClass("in-focus", "focusin" == t.type)
    })), e(document).on("shopify:section:load", (function () {
      e(".input-wrapper input, .input-wrapper textarea").trigger("inputstateEmpty")
    })), e(".input-wrapper input:focus, .input-wrapper textarea:focus").closest(".input-wrapper").addClass("in-focus"), e(".input-wrapper input, .input-wrapper textarea").trigger("inputstateEmpty"), e(".input-wrapper input, .input-wrapper textarea").on("animationstart", (function (t) {
      "onAutoFillStart" == t.originalEvent.animationName ? e(this).closest(".input-wrapper").removeClass("is-empty") : "onAutoFillCancel" == t.originalEvent.animationName && e(this).trigger("inputstateEmpty")
    })), e(window).width() > 1024 && e("input[data-desktop-autofocus]").focus(), e(document).on("click assess", ".tabs a", (function (t) {
      e(this).addClass("tab--active").closest("ul").find(".tab--active").not(this).removeClass("tab--active"), e(this).closest("li").siblings().find("a").each((function () {
        e(e(this).attr("href")).removeClass("tab-content--active")
      })), e(e(this).attr("href")).addClass("tab-content--active"), t.preventDefault()
    })), t(), e(document).on("shopify:section:load", t), e(document).on("click", ".js-contains-quickbuy .js-quickbuy-button", (function (t) {
      if (e(window).width() > 768) {
        var i = e(this), s = e(this).closest(".js-contains-quickbuy"),
          o = e('<div class="quickbuy">' + s.find(".quickbuy-placeholder-template").html() + "</div>"), n = !1,
          a = new MutationObserver((function (t) {
            e.colorbox.resize()
          }));
        return e.colorbox({
          closeButton: !1,
          preloading: !1,
          open: !0,
          speed: 200,
          slideshow: !0,
          html: [o.wrap("<div>").parent().html()].join(""),
          onComplete: function () {
            var t = e(".quickbuy__product-media").slick({
              infinite: !1,
              slidesToScroll: 1,
              speed: 300,
              slidesToShow: 1,
              swipeToSlide: !0,
              variableWidth: !0,
              waitForAnimate: !1,
              prevArrow: e(".quickbuy__slider-controls .prev"),
              nextArrow: e(".quickbuy__slider-controls .next")
            });
            theme.ProductMedia.init(e(".quickbuy__media-container"), {
              onPlyrInit: function (e) {
                theme.productGallerySlideshowTabFix(t.slick("getSlick").$slides, t.slick("getSlick").currentSlide)
              }, onYoutubeInit: function (e) {
                theme.productGallerySlideshowTabFix(t.slick("getSlick").$slides, t.slick("getSlick").currentSlide)
              }, onModelViewerInit: function (e) {
                theme.productGallerySlideshowTabFix(t.slick("getSlick").$slides, t.slick("getSlick").currentSlide)
              }, onVideoVisible: function (t) {
                e(t.target).closest(".slick-slider").slick("slickSetOption", "swipe", !1)
              }, onVideoHidden: function (t) {
                e(t.target).closest(".slick-slider").slick("slickSetOption", "swipe", !0)
              }, onPlyrPlay: function (t) {
                e(t.target).closest(".slick-slider").slick("slickSetOption", "swipe", !1)
              }, onPlyrPause: function (t) {
                e(t.target).closest(".slick-slider").slick("slickSetOption", "swipe", !0)
              }, onModelViewerPlay: function (t) {
                e(t.target).closest(".slick-slider").slick("slickSetOption", "swipe", !1).slick("slickSetOption", "accessibility", !1).closest(".quickbuy__media-container").addClass("media-playing")
              }, onModelViewerPause: function (t) {
                e(t.target).closest(".slick-slider").slick("slickSetOption", "swipe", !0).slick("slickSetOption", "accessibility", !0).closest(".quickbuy__media-container").removeClass("media-playing")
              }
            }), t.find(".product-media").trigger("mediaVisibleInitial"), t.on("afterChange", (function (i, s, o) {
              e(".product-media--activated").removeClass("product-media--activated").trigger("mediaHidden");
              var n = e(".product-media", s.$slides[o]).addClass("product-media--activated").trigger("mediaVisible");
              theme.productGallerySlideshowTabFix(s.$slides, o), t.closest(".quickbuy__media-container").toggleClass("quickbuy__media-container--current-image", n.hasClass("product-media--image")), e(this).closest(".quickbuy-container").trigger("changedsize")
            })), theme.productGallerySlideshowTabFix(t.slick("getSlick").$slides, t.slick("getSlick").currentSlide), e.colorbox.resize();
            var o = e(".quickbuy-form"), r = JSON.parse(e("[data-product-json]", s).html()), c = {
              $container: o,
              enableHistoryState: !1,
              singleOptionSelector: "[data-single-option-selector]",
              originalSelectorId: "[data-product-select]",
              secondaryIdSelectors: "[data-product-secondary-select]",
              product: r,
              productSingleObject: r
            };
            new slate.Variants(c), o.on("variantChange", theme.variants.updateAddToCartState.bind(c)), o.on("variantPriceChange", theme.variants.updateProductPrices.bind(c)), e(".quickbuy__product-media .slick-slide", o).length > 1 && o.on("variantImageChange", (function (t) {
              var i = e('.quickbuy__product-media .slick-slide:not(.slick-cloned)[data-media-id="' + t.variant.featured_media.id + '"]', o);
              i.length && i.closest(".slick-slider").slick("slickGoTo", i.data("slick-index"))
            })), o.on("variantChange", e.colorbox.resize), theme.initVariantSelectors(e(".quickbuy .option-selector"), c.product, !0), e(document).trigger("cc:component:load", ["custom-select", ".quickbuy"]), Shopify.PaymentButton && (e(document).on("shopify:payment_button:loaded.themeQuickBuy", (function () {
              e(document).off("shopify:payment_button:loaded.themeQuickBuy"), e.colorbox.resize(), (n = e(".quickbuy-form .shopify-payment-button")[0]) && a.observe(n, {
                attributes: !0,
                childList: !0,
                subtree: !0
              })
            })), Shopify.PaymentButton.init()), theme.initAjaxAddToCartForm(e("form.ajax-product-form", o));
            for (var l = {
              handle: r.handle,
              url: i.attr("href").split("?")[0],
              title: r.title,
              vendor: r.vendor,
              available: r.available,
              image: r.media && r.media.length > 0 ? r.media[0].preview_image.src : null,
              image2: r.media && r.media.length > 1 ? r.media[1].preview_image.src : null,
              price: r.price,
              priceVaries: r.price_varies,
              compareAtPrice: r.compare_at_price
            }, d = r.variants[0], h = 1; h < r.variants.length; h++) r.variants[h].price < d.price && (d = r.variants[h]);
            d.unit_price_measurement && (l.unitPrice = d.unit_price, l.unitPriceUnit = theme.variants.getBaseUnit(d)), theme.addToAndReturnRecentProducts(l)
          },
          onCleanup: function () {
            a.disconnect(), theme.ProductMedia.destroy(e(".quickbuy__media-container")), e(".quickbuy .slick-initialized").slick("unslick").off("afterChange"), e(".quickbuy-form").off("variantChange variantPriceChange variantImageChange"), theme.initAjaxAddToCartForm(e(".quickbuy form.ajax-product-form"))
          }
        }), !1
      }
    })), e(document).on("click", "#colorbox .quickbuy__close .js-close-quickbuy", (function () {
      return e.colorbox.close(), !1
    })), e(document).on("click", ".js-close-lightbox", (function () {
      return e.colorbox.close(), !1
    })), e(document).on("change", ".qty-wrapper > .cc-select", (function () {
      var t = e(this).find('[aria-selected="true"]').data("value"),
        i = e(this).siblings(".qty-actual").find('[name="quantity"]');
      "10+" == t ? (i.val("10").closest(".qty-wrapper").addClass("hide-proxy"), setTimeout((function () {
        i.select().focus()
      }), 10)) : i.val(t)
    }));
    var i = e(".subscribe-form__response--success");
    i.length && !e(".cc-popup-form__response--success").length && e.colorbox({
      transition: "fade",
      html: '<div class="subscribe-form-lightbox-response">' + i.html() + "</div>",
      onOpen: function () {
        e("#colorbox").css("opacity", 0)
      },
      onComplete: function () {
        e("#colorbox").animate({opacity: 1}, 350)
      }
    }), e(".accent-background").length && (e((function () {
      theme.resizeAccent()
    })), e(window).on("debouncedresize", theme.resizeAccent), e(document).on("shopify:section:load", (function (t) {
      e(t.target).prev().hasClass("accent-background") && theme.resizeAccent()
    })), e(document).on("shopify:section:reorder", theme.resizeAccent))
  })), e(".slider-div-se").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: !1,
    fade: !0,
    asNavFor: ".slider-nav",
    dots: !1,
    responsive: [{breakpoint: 767, settings: {dots: !1, slidesToShow: 1}}]
  }), e(".slider-nav").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: ".slider-div-se",
    dots: !1,
    arrows: !0,
    centerMode: !1,
    focusOnSelect: !0,
    variableWidth: !0,
    prevArrow: "<img class='a-left control-c prev slick-prev' src='https://cdn-icons-png.flaticon.com/512/271/271220.png'>",
    nextArrow: "<img class='a-right control-c next slick-next' src='https://cdn-icons-png.flaticon.com/512/32/32213.png'>",
    responsive: [{breakpoint: 557, settings: {slidesToShow: 4, slidesToScroll: 1}}]
  }), theme.Sections.init(), theme.Sections.register("header", theme.Header, {deferredLoad: !1}), theme.Sections.register("footer", theme.Footer), theme.Sections.register("product", theme.Product, {deferredLoad: !1}), theme.Sections.register("blog", theme.Blog), theme.Sections.register("article", theme.Article), theme.Sections.register("slideshow", theme.Slideshow), theme.Sections.register("banner", theme.Banner), theme.Sections.register("standout-collection", theme.StandoutCollection), theme.Sections.register("get-the-look", theme.GetTheLook), theme.Sections.register("promotional-images", theme.PromotionalImages), theme.Sections.register("featured-collection", theme.FeaturedCollection), theme.Sections.register("list-collections", theme.ListCollections, {deferredLoad: !1}), theme.Sections.register("cart", theme.Cart, {deferredLoad: !1}), theme.Sections.register("image-with-text", theme.ImageWithText), theme.Sections.register("featured-product", theme.FeaturedProduct), theme.Sections.register("recently-viewed", theme.RecentlyViewed), theme.Sections.register("testimonials", theme.Testimonials), theme.Sections.register("gallery", theme.Gallery), theme.Sections.register("video", theme.VideoManager), theme.Sections.register("background-video", theme.VideoManager), theme.Sections.register("search-template", theme.SearchTemplate, {deferredLoad: !1}), e((function (e) {
    n.sections.length ? n.sections.forEach((e => {
      try {
        var t = {};
        void 0 !== e.deferredLoad && (t.deferredLoad = e.deferredLoad), void 0 !== e.deferredLoadViewportExcess && (t.deferredLoadViewportExcess = e.deferredLoadViewportExcess), theme.Sections.register(e.name, e.section, t)
      } catch (t) {
        console.error("Unable to register section ".concat(e.name, "."), t)
      }
    })) : console.warn("Barry: No common sections have been registered.")
  }))
}(theme.jQuery);


 $(document).ready(function(){
    $("*").each(function(){
      if($(this).text().includes("3 Year Warranty")){
        $(this).html($(this).html().replace(/3\s*Year\s*Warranty/gi, "90 Day Warranty"));
      }
    });
  });








document.addEventListener("DOMContentLoaded", function () {
  const forms = document.querySelectorAll('form[action="/cart/add"]');

  forms.forEach(function (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault(); // Prevent default form submission

      const formData = new FormData(form);
      const variantId = formData.get("id");

      if (!variantId) {
        alert("Product ID not found.");
        return;
      }

      // Step 1: Add selected product to cart (without clearing)
      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          console.log("Product added:", data);
          // Redirect to cart or show confirmation
          window.location.href = "/cart";
        })
        .catch((err) => {
          console.error("Error:", err);
          alert("کچھ غلطی ہو گئی، دوبارہ کوشش کریں۔");
        });
    });
  });
});




 document.addEventListener("DOMContentLoaded", function () {
  const unwantedItem = document.querySelector(
    'li#superhandige-multifunctionele-huisdierhaarverwijderaar'
  );
  
  if (unwantedItem) {
    unwantedItem.remove(); // permanently remove the item from sidebar
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const allCartItems = document.querySelectorAll("li.cart-item-container");
  
  allCartItems.forEach(function (item) {
    const variantId = item.getAttribute("id"); // or use dataset if available
    
    if (variantId === "superhandige-multifunctionele-huisdierhaarverwijderaar") {
      item.remove();
    }
  });
});
